{
  "account.emptyFavoriteBrands.subTitle": "Favoritmarkera dina varumärken och få notiser om nyheter och kampanjer",
  "account.emptyFavoriteBrands.title": "Håll koll på dina favoritvarumärken",
  "account.emptyFavorites.subTitle": "Favoritmarkera dina produkter och få notiser om nyheter och kampanjer",
  "account.emptyFavorites.title": "Håll koll på dina favoritprodukter",
  "account.emptyOrder.cta": "Börja handla",
  "account.emptyOrder.subTitle": "Så fort du har beställt något så kommer din senaste order att ligga här.",
  "account.emptyOrder.subTitle.selection": "Välj ett annat år eller urval för att se ordrar.",
  "account.emptyOrder.title": "Du har inte beställt något ännu",
  "account.emptyOrder.title.selection": "Du inga ordrar för det valda året",
  "account.emptyOrder.title.emptyQuery": "Välj företag i filtret",
  "account.favoriteBrandsCta": "Alla varumärken",
  "account.favoriteBrandsHeading": "Favoritmärken",
  "account.favoritesCta": "Alla produkter",
  "account.favoritesHeading": "Favoriter",
  "account.latestOrderHeading": "Senaste ordern",
  "account.seeAll": "Se alla",
  "addedToCart.fail": "Det gick tyvärr inte att lägga till i varukorgen just nu",
  "addedToCart.headline": "Tillagd",
  "addedToCart.numProductsAdded": "{num} produkter lades till i varukorgen",
  "apiError.unauthorized": "Du har inte rätt att utföra åtgärden. Kontakta support",
  "apiError.unknown": "Ett okänt fel har inträffat. Kontakta support",
  "articles.keyword.articles": "Artiklar",
  "articles.keyword.articles.read": "Läs artikeln",
  "articles.keyword.guides": "Guider",
  "articles.keyword.guides.read": "Läs guiden",
  "articles.keyword.interviews": "Intervjuer",
  "articles.keyword.interviews.read": "Läs intervjun",
  "articles.keyword.news": "Nyheter",
  "articles.keyword.news.read": "Läs nyheten",
  "articles.keyword.funny": "Roliga",
  "articles.latestBtn": "Senaste",
  "articles.loadmore": "Ladda fler",
  "articles.read": "Läs",
  "articles.relatedHeadline": "Relaterade artiklar",
  "articles.total.none": "Inga artiklar",
  "articles.total.plur": "{num} artikar",
  "articles.total.sing": "1 artikel",
  "articles.viewed": "Du har tittat på {current} av {total} artiklar",
  "articles.keyword.nyheter": "Nyheter",
  "body.inputWithDropdown.multipleItemsSelected": "{itemCount} valda",
  "brandlist.allCategories": "Alla märken a-ö",
  "brandlist.favorites.headline": "Dina favoriter",
  "checkout.backToShopping": "Fortsätt handla",
  "checkout.invoice.notAvailableForCompany": "{companyName} får inte handla på faktura",
  "checkout.cartSettings.closeCta": "Dölj orderinställningar",
  "checkout.cartSettings.openCta": "Visa orderinställningar",
  "checkout.customAddressRadio": "Skicka till arbetsplats",
  "checkout.customerSuccessProducts.closeCta": "Dölj ytterligare produkter",
  "checkout.customerSuccessProducts.openCta": "Visa ytterligare produkter",
  "checkout.customerSuccessProducts.placeholder": "Skriv meddelande...",
  "checkout.customerSuccessProducts.noProducts": "Du har lagt till alla tillgängliga ytterligare produkter.",
  "checkout.empty": "Din varukorg är tom",
  "checkout.expeditedDelivery.label": "Prioriterad leverans",
  "checkout.extendedPaymentTime.label": "Förläng betalningsdatumet",
  "checkout.shipInStockNow.label": "Skicka varor i lager omgående",
  "checkout.invoice.billingInputHeadline": "Leveransadress",
  "checkout.invoice.completePurchase": "Slutför köp",
  "checkout.invoice.deliveryMethodsHeadline": "Leveranssätt",
  "checkout.invoice.genericError": "Något gick fel, var god försökt igen eller kontakta kundtjänst",
  "checkout.invoice.paymentMethodsHeadline": "Betalningsmetod",
  "checkout.invoice.summaryHeadline": "Ordersumma",
  "checkout.leadtimeSuffix": "arbetsdagar",
  "checkout.newsletterHeadline": "Du finns inte med på vår nyhetsbrevslista",
  "checkout.newsletterLabel": "Skicka nyhetsbrev med nyheter och erbjudanden",
  "checkout.checkoutType.headline": "Vad vill du göra?",
  "checkout.checkoutType.purchase": "Slutföra köp åt kund",
  "checkout.checkoutType.orderProposal": "Skapa orderförslag åt kund",
  "checkout.orderProposal.headline.create": "Skapa orderförslag åt kund",
  "checkout.orderProposal.addComment": "Lägg till en kommentar",
  "checkout.orderProposal.resend": "Skicka om orderförslag",
  "checkout.orderProposal.saveDraft": "Spara utkast",
  "checkout.orderProposal.updateDraft": "Uppdatera utkast",
  "checkout.orderProposal.update": "Uppdatera orderförslag",
  "checkout.orderProposal.updated": "Orderförslaget uppdaterades",
  "checkout.orderProposal.send": "Skicka orderförslag",
  "checkout.orderProposal.sentAt": "Orderförslag skickat {time}",
  "checkout.orderProposal.editDiscount": "Lägg till rabatterad produkt",
  "checkout.orderProposal.noDiscounts": "Det finns inga specifika säljarrabatter för denna produkt.",
  "checkout.orderProposal.saveDiscount": "Spara och stäng",
  "checkout.orderProposal.saved": "Utkast sparat",
  "checkout.orderProposal.savedAt": "Utkast sparat {time}",
  "checkout.orderProposal.sent": "Orderförslag skickat till {name}",
  "checkout.orderProposal.validUntil": "Välj giltighetstid",
  "checkout.orderProposal.week": "vecka",
  "checkout.orderProposal.weeks": "veckor",
  "checkout.orderProposal.cancel": "Avbryt",
  "checkout.orderProposal.addMore": "Lägg till fler produkter",
  "checkout.pageTitle": "Kassan",
  "checkout.pageTitle.fail": "Fel i betalning",
  "checkout.pageTitle.success": "Tack för ditt köp",
  "checkout.salonRadio": "Skicka till",
  "checkout.salonSelectLabel": "Välj företag",
  "checkout.saveShippingAction": "Spara leveransadress",
  "checkout.shippingSavedMessage": "Adress sparad",
  "checkout.signup.alreadyMember": "Är du redan medlem?",
  "checkout.support": "Behöver du hjälp?",
  "checkout.verifyDetails": "Verifiera uppgifterna",
  "checkout.verifyDetails.payer": "Betalare",
  "checkout.verifyDetails.notCorrectHeadline": "Stämmer inte uppifterna?",
  "checkout.verifyDetails.notCorrectText": "Prova att ladda om sidan. Om det inte hjälper klicka på \"Rensa varukorg\" och gör om din beställning.",
  "checkout.verifyDetails.clearBasket": "Rensa varukorg",
  "country.at": "Österrike",
  "country.dk": "Danmark",
  "country.fi": "Finland",
  "country.no": "Norge",
  "country.se": "Sverige",
  "country.selectCountry": "Välj land",
  "country.uk": "UK",
  "country.de": "Tyskland",
  "countrySelection.title": "Hej, vill du handla i Österrike eller Tyskland?",
  "customer.company": "Företag",
  "customer.modalHeadline": "Hej där! Privat eller företag?",
  "customer.privatePerson": "Privatperson",
  "dropdown.generic": "Välj",
  "error.generic": "Något gick fel, var god försök igen eller kontakta kundtjänst",
  "error500.button": "Gå till startsidan",
  "error500.headline": "Det här är pinsamt…",
  "error500.subheadline": "Något har gått fel hos oss. Vi är medvetna om detta och arbetar på att åtgärda det.",
  "error500.try1": "Uppdatera sidan (ibland hjälper det)",
  "error500.try2": "Försök igen om 30 minuter",
  "error500.try3": "Kontakta <a href=\"mailto:kundservice@kahrs.se\">kundservice@kahrs.se</a>",
  "error500.tryHeadline": "Funkar inte sidan? Prova att:",
  "compare.button.add": "Lägg till för jämförelse",
  "compare.button.remove": "Ta bort från jämförelse",
  "compare.sticky.button": "Jämför ({count})",
  "compare.sticky.heading": "Jämför golv",
  "compare.sticky.selected": "{count} av {max} valda",
  "compare.sticky.empty-slot": "Tom plats",
  "compare.sticky.clear-all": "Rensa alla",
  "compare.page.tagline": "Jämför golv",
  "compare.page.heading": "Sida vid sida-jämförelse",
  "compare.page.differences": "Skillnader markerade",
  "compare.page.remove": "Ta bort {name}",
  "compare.page.viewProduct": "Visa produkt",
  "compare.page.addFloor": "Lägg till ett golv",
  "compare.page.compareUpTo": "Jämför upp till {max}",
  "compare.page.searchFloors": "Sök efter golv",
  "compare.page.browseFloors": "Bläddra bland golv",
  "favorite.outOfStock": "Slut i lager",
  "favorite.button.add": "Lägg till som favorit",
  "favorite.button.add.brand": "Lägg till som favorit",
  "favorite.button.remove": "Ta bort favorit",
  "favorite.button.remove.brand": "Tillagd i favoriter",
  "favorites.btnCta": "Lägg alla i varukorgen",
  "favorites.btnSecondaryCta": "Töm listan",
  "favorites.discountLabel": "Rabatt",
  "favorites.pointsLabel": "Poäng på köpet",
  "favorites.priceTitle": "Listans totalpris",
  "favorites.totalPriceLabel": "Delsumma inkl. moms",
  "favorites.totalPriceExTaxLabel": "Delsumma exkl. moms",
  "favorites.totalVat": "Moms",
  "filter.button": "Filtrera",
  "filter.button.clear": "Rensa",
  "filter.button.show.plur": "Visa {num} produkter",
  "filter.countResults.plur": "{num} produkter",
  "filter.countResults.sing": "1 produkt",
  "filter.jumpToProducts": "Se alla produkter",
  "filter.loadmore": "Visa fler",
  "filter.modalTitle": "Filtrera",
  "filter.name.brandFilters": "Varumärke",
  "filter.search.category": "Sök {category}",
  "filter.sort.alpha_asc": "Bokstavsordning",
  "filter.sort.alpha_desc": "Z -> A",
  "filter.sort.default": "Populära",
  "filter.sort.prefix": "Sortera:",
  "filter.sort.price_asc": "Pris: Lägst först",
  "filter.sort.price_desc": "Pris: Högst först",
  "filter.sort.title": "Sortering",
  "filter.viewed": "Du har tittat på {current} av {total} produkter",
  "filter.selected": "valda",
  "footer.newsletter.content": "Prenumerera på vårt nyhetsbrev och ta del av nyheter, speciella erbjudanden, sköna tips och intressant läsning.",
  "footer.newsletter.error": "Det gick inte att registrera dig för nyhetsbrevet för tillfället. Vänligen försök igen senare!",
  "footer.newsletter.headline": "Nyhetsbrev",
  "footer.newsletter.placeholder": "Ange din e-postadress",
  "footer.newsletter.welcome": "Välkommen, {email} är nu registrerad till vårt nyhetsbrev!",
  "form.back": "Tillbaka",
  "form.invalid.email": "Ogiltig e-post",
  "form.invalid.max_chars": "Max {max} tecken",
  "form.invalid.min_chars": "Minst {min} tecken",
  "form.invalid.phone": "Ogiltigt telefonnummer",
  "form.invalid.postal_code": "Ogiltigt postnummer",
  "form.invalid.required": "Måste fyllas i",
  "form.invalid.noLeadingSpaces": "Får inte börja med mellanslag",
  "form.placeholder.city": "Ort",
  "form.placeholder.companyName": "Företagsnamn",
  "form.placeholder.country": "Land",
  "form.placeholder.email": "E-postadress",
  "form.placeholder.firstName": "Förnamn",
  "form.placeholder.lastName": "Efternamn",
  "form.placeholder.message": "Meddelande..",
  "form.placeholder.orderNumber": "Ordernummer",
  "form.placeholder.orgNo": "Organisationsnummer",
  "form.placeholder.phone": "Telefonnummer",
  "form.placeholder.street": "Adress",
  "form.placeholder.zip": "Postnummer",
  "header.cart": "Varukorg",
  "header.favorites": "Favoriter",
  "header.impersonate": "Se som kund",
  "header.menu": "Meny",
  "header.menu.open": "Öppna meny",
  "header.myPage": "Mina sidor",
  "header.sellerTools": "Säljverktyg",
  "header.countryManagerTools": "Landschefsverktyg",
  "header.customerSuccessImpersonate": "Logga in som kund",
  "impersonateModal.title": "Se som kund",
  "impersonateModal.search": "Sök kund",
  "impersonateModal.customerSuccess.title": "Logga in som kund",
  "impersonateModal.customerSuccess.placeholder": "Sök på kund eller kundnummer",
  "impersonateModal.customerSuccess.cta": "Logga in som",
  "impersonateModal.customerSuccess.stopImpersonating": "Sluta se som kund",
  "impersonateModal.customerSuccess.success": "Kund hittad, loggar in som {{companyName}}",
  "impersonateModal.customerSuccess.error": "Kunden hittades inte, försök igen",
  "impersonateModal.customerSuccess.loggedInAs": "Inloggad som",
  "impersonate.error.missingCode": "Företaget saknar kod.",
  "impersonate.stop": "Sluta se som kund",
  "invite.accept.button": "Färdigställ konto",
  "invite.accept.error": "Länken du har följt är felaktig. Kontrollera länken eller kontakta support",
  "invite.accept.finished": "Ditt konto är nu klart och du kommer loggas in automatiskt inom kort.",
  "invite.accept.headline": "Acceptera inbjudan",
  "invite.accept.text": "Fyll i dina uppgifter för att aktivera ditt konto",
  "invoice.filter.all": "Visa alla",
  "invoice.filter.paid": "Betald",
  "invoice.filter.pending": "Inväntar betalning",
  "invoice.filter.refunded": "Återbetald",
  "invoice.status.paid": "Betald",
  "invoice.status.pastDue": "Förfallen",
  "invoice.status.pending": "Inväntar betalning",
  "invoice.status.refunded": "Återbetald",
  "invoice.status.paidLate": "Betald försent",
  "invoices.table.invoiceDate": "Fakturadatum",
  "invoices.table.invoiceNumber": "Fakturanummer",
  "invoices.table.status": "Status",
  "invoices.table.total": "Total sum",
  "invoices.title": "Invoices",
  "loadCart.placeholder": "Load a cart with id",
  "loadCart.submit": "Load",
  "loadCart.validation": "Id contains only numbers",
  "loading": "Loading",
  "lockedPage.headline": "Sign in or register to get access to this page",
  "lockedPage.text": "This page is locked.",
  "marketPopup.title": "Vill du byta till svenska sajten?",
  "marketPopup.body": "Sortiment för den svenska marknaden, priser i kronor och återförsäljare nära dig.",
  "marketPopup.cta": "Gå till",
  "marketPopup.stay": "Stanna kvar",
  "mediaBank.downloadNettoAssortment": "Download netto assortment",
  "mediaBank.card.article": "Article",
  "mediaBank.card.download": "Download",
  "mediaBank.card.open": "Open",
  "mediaBank.card.preview": "Preview",
  "mediaBank.card.type": "Type",
  "mediaBank.selected.button": "Selected",
  "mediaBank.selected.clearConfirm": "Click again to clear",
  "mediaBank.selected.downloadAll": "Download All Selected",
  "mediaBank.selected.downloading": "Preparing download...",
  "mediaBank.selected.exportExcel": "Export to Excel",
  "mediaBank.selected.empty": "You haven't selected any assets yet",
  "mediaBank.selected.title": "Selected",
  "mediaBank.error.downloadFailed": "Failed to download files. Please try again.",
  "mediaBank.filter.productType": "Product Type",
  "mediaBank.filter.clear": "Clear all",
  "mediaBank.filter.documentType": "Document Type",
  "mediaBank.filter.imageType": "Image Type",
  "mediaBank.filter.imageType.accessories": "Tillbehör",
  "mediaBank.filter.imageType.accessory": "Tillbehör",
  "mediaBank.filter.imageType.cad": "CAD",
  "mediaBank.filter.imageType.illustration": "Illustration",
  "mediaBank.filter.imageType.inspiration": "Inspiration",
  "mediaBank.filter.imageType.interior": "Interiör",
  "mediaBank.filter.imageType.schematic": "Schema",
  "mediaBank.filter.imageType.swatch": "Prov",
  "mediaBank.filter.imageType.swatchCloseup": "Närbild på prov",
  "mediaBank.filter.mediaType": "Media Type",
  "mediaBank.filter.mediaType.documents": "Documents",
  "mediaBank.filter.mediaType.images": "Images",
  "mediaBank.filter.roomType": "Room Type",
  "mediaBank.filter.roomType.bedroom": "Sovrum",
  "mediaBank.filter.roomType.diningroom": "Matsal",
  "mediaBank.filter.roomType.kitchen": "Kök",
  "mediaBank.filter.roomType.livingroom": "Vardagsrum",
  "mediaBank.filter.roomType.office": "Kontor",
  "mediaBank.filter.roomType.other": "Övrigt",
  "mediaBank.filter.roomType.publicspaces": "Offentliga miljöer",
  "mediaBank.filter.roomType.residential": "Bostad",
  "mediaBank.filter.show": "Show {num} results",
  "mediaBank.filters.button": "Filters",
  "mediaBank.filters.title": "Filters",
  "mediaBank.loadMore": "Load more",
  "mediaBank.loadMore.remaining": "remaining",
  "mediaBank.loginBanner.description": "Logga in för att få tillgång till bilder, logotyper och övrigt innehåll",
  "mediaBank.noResults": "No results found",
  "mediaBank.searchPrompt": "Search for products to find media assets",
  "mediaBank.preview.addSelected": "Select",
  "mediaBank.preview.download.digital": "For digital use",
  "mediaBank.preview.download.document": "Download",
  "mediaBank.preview.download.jpg": "Download JPG (sRGB)",
  "mediaBank.preview.download.print": "For print",
  "mediaBank.preview.download.tiff": "Download TIFF (AdobeRGB)",
  "mediaBank.preview.downloadOptions": "Download Options",
  "mediaBank.preview.openNewTab": "Open in new tab",
  "mediaBank.preview.fields.articleNumber": "Article number",
  "mediaBank.preview.fields.collection": "Collection",
  "mediaBank.preview.fields.documentType": "Document type",
  "mediaBank.preview.fields.imageType": "Image type",
  "mediaBank.preview.fields.variant": "Variant",
  "mediaBank.preview.removeSelected": "Remove selection",
  "mediaBank.results": "{num} results",
  "mediaBank.search.placeholder": "Search by product name, article number, or collection...",
  "mediaBank.terms.accept": "Accept & Download",
  "mediaBank.terms.body": "By downloading media from this library, you agree to use these assets in accordance with our brand guidelines and usage policies. These media assets are provided exclusively for B2B customers and may only be used for purposes related to marketing, sales, and distribution of our products. Unauthorized use, reproduction, or distribution of these assets is strictly prohibited.",
  "mediaBank.terms.cancel": "Cancel",
  "mediaBank.terms.checkbox": "I accept the terms for using these media assets",
  "mediaBank.terms.title": "Media Usage Terms",
  "mediaBank.title": "Media Bank",
  "mediaBank.loginRequired": "Please log in to access the Media Bank",
  "miniCart.multipleDeliveries.merge": "Slå ihop ordern till ett utleveransdatum • Förväntat utlastningsdatum {date}",
  "miniCart.multipleDeliveries.mergeSuccess": "Ordern har slagits ihop till ett utleveransdatum",
  "miniCart.multipleDeliveries.shipment": "Leverans",
  "miniCart.multipleDeliveries.title": "Ordern levereras i {shipments} leveranser utan extra kostnad.",
  "miniCart.preferredShippingDate": "Önskat utlastningsdatum",
  "miniCart.preferredShippingDateShort": "Önskat utlastningsdatum",
  "miniCart.preferredShippingDate.disclaimer": " ",
  "miniCart.quantityBreak": "Lägg till {quantity} paket och få {discount}% rabatt",
  "miniCart.shipping.calculatedInCheckout": "Frakt beräknas i kassan",
  "miniCart.splitDelivery.description": "Önskar du delleverans? Kommentera nedan",
  "miniCart.splitDelivery.text": "Artikeln levereras när {amount} finns i lager",
  "minicart.barcode.scan": "Skanna produkt",
  "minicart.crossdocking.contentFirst": "Du kan fortfarande genomföra köpet men produkten/produkterna kommer skickas med din nästa beställning.",
  "minicart.crossdocking.contentSecond": "Du kan även kryssa i checkboxen för att få produkten skickade när det åter är i lager för en extra fraktkostnad på 69 kr per produkt.",
  "minicart.crossdocking.title": "OBS! Din varukorg innehåller en eller flera produkter som för tillfället är slut i lager.",
  "minicart.discount.abort": "Avbryt",
  "minicart.discount.activate": "Tillämpa",
  "minicart.discount.button": "Lägg till rabattkod",
  "minicart.discount.invalidCode": "Ogiltig kod eller kraven uppfylls inte",
  "minicart.discount.invalidDiscount": "Ogiltig rabatt",
  "minicart.discount.placeholder": "Ange rabattkod",
  "minicart.empty": "Din varukorg är tom",
  "minicart.freeShippingReached": "Fri frakt uppnådd. Tips till dig:",
  "minicart.headline": "Varukorg",
  "minicart.leftToFreeShipping": "Handla för {amount} kr till så bjuder vi på frakten",
  "minicart.progressbar.full": "Du har uppnått fri frakt!",
  "minicart.progressbar.left": "{sum} kvar till fri frakt",
  "minicart.summary.discount": "Du sparar",
  "minicart.summary.exVat": "Totalsumma exkl. moms",
  "minicart.summary.freight": "Frakt",
  "minicart.summary.incVat": "Totalsumma inkl. moms",
  "minicart.summary.originalPrice": "Ord. pris {price}",
  "minicart.summary.points": "Poäng på köpet",
  "minicart.summary.pointsInfo": "Efter genomfört köp (om du handlat för minst {amount}) kan du handla backbars och testers för poängen",
  "minicart.summary.pointsSuffix": "poäng",
  "minicart.summary.sum": "Delsumma",
  "minicart.summary.vat": "Moms",
  "minicart.toCheckout": "Gå till kassan",
  "minicart.requestOrderProposal": "Begär offertförslag",
  "modal.requestOrderProposal.title": "Begär offertförslag",
  "modal.requestOrderProposal.successTitle": "Begäran skickad",
  "modal.requestOrderProposal.paragraph": "Du håller på att skicka artiklarna i din kundvagn till vårt säljteam. De kommer granska din förfrågan och skicka tillbaka ett personligt orderförslag baserat på ditt urval.",
  "modal.requestOrderProposal.formTitle": "Meddelande till säljaren",
  "modal.requestOrderProposal.formTooltip": "Hjälptext",
  "modal.requestOrderProposal.formPlaceholder": "Meddelande",
  "modal.requestOrderProposal.formPreFilled": "Hej, jag är intresserad av artiklarna i min kundvagn. Vänligen skicka mig ett förslag med priser och tillgänglighet.",
  "modal.requestOrderProposal.cta": "Skicka förfrågan till säljteamet",
  "modal.requestOrderProposal.cancel": "Avbryt",
  "modal.requestOrderProposal.successMessage": "Tack! Din förfrågan har skickats till vårt säljteam. Du kommer att få ett personligt orderförslag inom kort, och vi meddelar dig så snart det är klart.",
  "modal.requestOrderProposal.successCta": "Visa mina orderförslag",
  "modal.requestOrderProposal.successCancel": "Tillbaka till shopping",
  "modal.requestOrderProposal.summaryTitle": "Du begär ett förslag för följande produkter",
  "modal.generic.abort": "Avbryt",
  "modal.generic.delete": "Radera",
  "modal.generic.deleteText": "Är du säker på att du vill radera?",
  "modal.generic.ok": "Ok",
  "modal.generic.save": "Spara",
  "modal.generic.close": "Stäng",
  "modelModal.cta": "Byt modell",
  "modelModal.title": "Byt modell",
  "moodgallery.headline": "Färgen och känslan av {productName}",
  "multibuy.Samples.needMore": "Tre stycken konsumentprover är kostnadsfria, rabatten appliceras i kassan.\n\nBehöver du utställningsprover? Kontakta din säljare",
  "mypage.acceptOrderProposal.success": "Orderförslaget lades i varukorgen",
  "mypage.backorders": "Backorders",
  "mypage.backorders.deliveryDate": "Datum för utleverans",
  "mypage.backorders.description": "backorders desc",
  "mypage.backorders.mobile": "Backorders mobile",
  "mypage.backorders.product": "Produkt",
  "mypage.claims": "Reklamation",
  "mypage.communications.backorderStockAlerts": "Ja, skicka backorder status alerts",
  "mypage.communications.newsletter": "Ja tack, skicka gärna nyhetsbrev till mig!",
  "mypage.communications.subheadline": "Kommunikationsinställningar",
  "mypage.communications.text": "I nyhetsbrevet hittar du erbjudanden och nyheter. Du kan avsluta när du själv önskar. Självklart har vi på Kährs en tydlig integritetspolicy.",
  "mypage.communications.updated": "Kommunikationsinställningar uppdaterade",
  "mypage.confirmOrderproposalModalText": "Du har redan en aktiv varukorg med produkter i. Vill du behålla de produkterna eller ta bort dom?",
  "mypage.confirmOrderproposalModalTitle": "Vänligen bekräfta",
  "mypage.customer.searchPlaceholder": "Sök på kund eller kundnummer",
  "mypage.customer.seeAllOrders": "Se alla ordrar",
  "mypage.customer.seeAsCustomer": "Se som kund",
  "mypage.customer.selectedPlaceholder": "Vald kund",
  "mypage.customer.shopAsCustomer": "Handla som kund",
  "mypage.customer.stopShopAsCustomer": "Sluta handla som kund",
  "mypage.customer.title": "Mina kunder",
  "mypage.customers": "Mina kunder",
  "mypage.customersuccess.notimpersonating": "Vänligen välj att logga in som en kund genom att klicka på 'Logga in som kund' i toppen för att se mer information på mina sidor.",
  "mypage.declineOrderProposal.success": "Orderförslaget avvisades",
  "mypage.delivery.add": "Lägg till leveransadress",
  "mypage.delivery.change": "Ändra leveransadress",
  "mypage.delivery.sameAsInvoice": "Samma som fakturaadress",
  "mypage.deliveryAddress.delete": "Radere leveransadress",
  "mypage.deliveryAddresses": "Leveransadress",
  "mypage.edit": "Redigera",
  "mypage.edit.add": "Lägg till",
  "mypage.edit.email": "E-post",
  "mypage.edit.name": "Namn",
  "mypage.edit.password": "Lösenord",
  "mypage.edit.phone": "Telefonnummer",
  "mypage.edit.save": "Spara ändringar",
  "mypage.emptyOrderProposals.salesSubTitle": "När du har skapat ett orderförlag så kommer det dyka upp här",
  "mypage.emptyOrderProposals.salesTitle": "Du har inga orderförslag",
  "mypage.emptyOrderProposals.subTitle": "Så fort din säljare har skapat ett orderförlag så kommer det dyka upp här",
  "mypage.emptyOrderProposals.title": "Du har inga orderförslag",
  "mypage.fastOrder": "Skapa snabborder",
  "mypage.favorites": "Favoriter",
  "mypage.headline": "Mina sidor",
  "mypage.invoiceAddress": "Fakturaadress",
  "mypage.invoices": "Fakturor",
  "mypage.logout": "Logga ut",
  "mypage.nav.cs": "Kundtjänst",
  "mypage.notLoggedin": "Du är inte inloggad",
  "mypage.notifications.invoice.btn": "Se faktura",
  "mypage.notifications.invoice.text": "Du har en faktura som har förfallit och måste betalas omgående",
  "mypage.notifications.invoice.title": "Din faktura har förfallit",
  "mypage.notifications.orderProposal.btn": "Se orderförslag",
  "mypage.notifications.orderProposal.text": "Du har ett nytt orderförslag",
  "mypage.notifications.orderProposal.title": "Nytt orderförslag",
  "mypage.orderHistory": "Orderhistorik",
  "mypage.orderHistory.mobile": "Ordrar",
  "mypage.orderHistory.salesRepNotImpersonating": "Du behöver logga in som en kund för att lägga något i varukorgen",
  "mypage.orderHistory.salesRepNotImpersonatingCorrectCompany": "Du behöver logga in som kunden för den här ordern för att lägga den i varukorgen igen.",
  "mypage.orderProposal": "Orderförslag",
  "mypage.sampleRequest": "Provbeställning",
  "mypage.sampleRequests": "Provbeställningar",
  "mypage.sampleRequest.srNumber": "SR-nummer",
  "mypage.sampleRequest.empty": "Inga provbeställningar än.",
  "mypage.sampleRequest.new": "Ny provbeställning",
  "mypage.sampleRequest.builder.title": "Beställ prover",
  "mypage.sampleRequest.builder.backToList": "Tillbaka till mina provbeställningar",
  "mypage.sampleRequest.builder.selectStore": "Vilken butik gäller detta?",
  "mypage.sampleRequest.builder.tab.floor": "Golvprover",
  "mypage.sampleRequest.builder.tab.stands": "Ställ",
  "mypage.sampleRequest.builder.tab.brochures": "Broschyrer",
  "mypage.sampleRequest.builder.tab.signage": "Skyltar",
  "mypage.sampleRequest.builder.tab.sampleSets": "Provset",
  "mypage.sampleRequest.builder.signageInfo": "Till varje enhet ska en Top Graphic väljas. Till Waterfall och BIG-sample krävs dessutom en Wall Graphic.",
  "mypage.sampleRequest.builder.itemCount": "{count} artiklar",
  "mypage.sampleRequest.builder.lineCount": "{count} rader",
  "mypage.sampleRequest.builder.continue": "Vidare till beställning",
  "mypage.sampleRequest.floor.searchPlaceholder": "Sök golv, kollektion eller art.nr",
  "mypage.sampleRequest.floor.empty": "Inga prover matchar din sökning.",
  "mypage.sampleRequest.floor.discontinued": "Utgår",
  "mypage.sampleRequest.floor.filter.button": "Filtrera",
  "mypage.sampleRequest.floor.filter.title": "Filtrera prover",
  "mypage.sampleRequest.floor.filter.collection": "Kollektion",
  "mypage.sampleRequest.floor.filter.grading": "Sortering",
  "mypage.sampleRequest.floor.filter.treatment": "Ytbehandling",
  "mypage.sampleRequest.floor.filter.clear": "Rensa",
  "mypage.sampleRequest.floor.filter.showResults": "Visa resultat ({count})",
  "mypage.sampleRequest.floor.availableToday": "Finns idag: {count}",
  "mypage.sampleRequest.floor.inStock": "I lager: {count}",
  "mypage.sampleRequest.floor.unknownCollection": "Övrigt",
  "mypage.sampleRequest.floor.selectedCount": "{count} valda",
  "mypage.sampleRequest.floor.productCount": "{count} golv",
  "mypage.sampleRequest.simpleCategory.empty": "Inga artiklar tillgängliga i denna kategori än.",
  "mypage.sampleRequest.simpleCategory.free": "Kostnadsfri",
  "mypage.sampleRequest.simpleCategory.serviceArticle": "Beställs direkt via kundservice.",
  "mypage.sampleRequest.simpleCategory.serviceArticleContact": "Kontakta oss",
  "mypage.sampleRequest.cart.pageTitle": "Varukorg & leverans",
  "mypage.sampleRequest.cart.title": "Varukorg ({count} rader)",
  "mypage.sampleRequest.cart.subtitle": "Varje storlek ligger som en egen rad.",
  "mypage.sampleRequest.cart.addMore": "Lägg till artiklar",
  "mypage.sampleRequest.cart.empty": "Inga artiklar än.",
  "mypage.sampleRequest.cart.rowDiscount": "Radrabatt {percent}% · −{amount}",
  "mypage.sampleRequest.cart.remove": "Ta bort",
  "mypage.sampleRequest.cart.setRowDiscount": "Sätt radrabatt",
  "mypage.sampleRequest.cart.applyDiscount": "Lägg till",
  "mypage.sampleRequest.cart.height": "Höjd (cm)",
  "mypage.sampleRequest.cart.width": "Bredd (cm)",
  "mypage.sampleRequest.cart.heightWithMax": "Höjd (cm) — max {max}",
  "mypage.sampleRequest.cart.widthWithMax": "Bredd (cm) — max {max}",
  "mypage.sampleRequest.cart.freeSizeMaxExceeded": "Max {max} cm",
  "mypage.sampleRequest.cart.freeSizeAreaExceeded": "Överskrider max yta på {max} m²",
  "mypage.sampleRequest.cart.summary.rowDiscounts": "Radrabatter",
  "mypage.sampleRequest.cart.summary.discountNotice": "Din säljare kan sätta rabatt på beställningen innan den godkänns. Du ser den innan ordern skapas.",
  "mypage.sampleRequest.cart.summary.vat": "Moms",
  "mypage.sampleRequest.cart.summary.paymentMethod": "Betalsätt: Faktura",
  "mypage.sampleRequest.cart.submit": "Skicka för godkännande",
  "mypage.sampleRequest.checkout.labelSection.title": "Etikett & orientering",
  "mypage.sampleRequest.checkout.labelSection.orientation": "Orientering",
  "mypage.sampleRequest.checkout.labelSection.placement": "Etikettplacering",
  "mypage.sampleRequest.checkout.labelSection.portrait": "Stående",
  "mypage.sampleRequest.checkout.labelSection.landscape": "Liggande",
  "mypage.sampleRequest.checkout.labelSection.topLeft": "Uppe vänster",
  "mypage.sampleRequest.checkout.labelSection.topRight": "Uppe höger",
  "mypage.sampleRequest.checkout.labelSection.bottomLeft": "Nere vänster",
  "mypage.sampleRequest.checkout.labelSection.bottomRight": "Nere höger",
  "mypage.sampleRequest.checkout.labelSection.side": "On the side",
  "mypage.sampleRequest.checkout.deliverySection.title": "Leverans",
  "mypage.sampleRequest.checkout.deliverySection.toStore": "Skicka till butik",
  "mypage.sampleRequest.checkout.deliverySection.toAddress": "Leverera till annan adress",
  "mypage.sampleRequest.checkout.deliverySection.addressLine": "Adress",
  "mypage.sampleRequest.checkout.deliverySection.postalCode": "Postnr",
  "mypage.sampleRequest.checkout.deliverySection.city": "Ort",
  "mypage.sampleRequest.checkout.deliverySection.reference": "Ordernummer eller referens",
  "mypage.sampleRequest.checkout.deliverySection.instruction": "Leveransinstruktion",
  "mypage.sampleRequest.checkout.deliverySection.leadTime": "Standard leverans",
  "mypage.sampleRequest.checkout.deliverySection.leadTimeNotice": "Beräknad leverans 4 veckor efter godkännande",
  "mypage.sampleRequest.checkout.contactSection.notificationChannel": "Meddela mig via",
  "mypage.sampleRequest.checkout.contactSection.sms": "SMS",
  "mypage.sampleRequest.checkout.contactSection.both": "Båda",
  "mypage.sampleRequest.checkout.contactSection.emailDescription": "Spårningslänk skickas till e-postadressen.",
  "mypage.sampleRequest.checkout.contactSection.smsDescription": "Spårningslänk skickas via SMS.",
  "mypage.sampleRequest.checkout.contactSection.bothDescription": "Spårningslänk skickas både via e-post och SMS.",
  "mypage.sampleRequest.checkout.contactSection.contactPerson": "Välj vilken person hos kunden som ska stå som referens",
  "mypage.sampleRequest.checkout.contactSection.createNew": "Fyll i namn",
  "mypage.sampleRequest.checkout.contactSection.enterName": "Ange namn...",
  "mypage.sampleRequest.cart.summary.floorGroup": "Prover, trä & vinyl",
  "mypage.sampleRequest.cart.summary.otherGroup": "Övrigt",
  "mypage.sampleRequest.cart.summary.vatWithPercent": "Moms ({percent}%)",
  "mypage.sampleRequest.detail.rejectionTitle": "Meddelande från din säljare",
  "mypage.sampleRequest.detail.editAndResend": "Redigera och skicka in på nytt",
  "mypage.sampleRequest.detail.sellerMessageTitle": "Meddelande från säljaren",
  "mypage.sampleRequest.detail.orderNumber": "Ordernummer: {orderNo}",
  "mypage.sampleRequest.detail.orderNumberLabel": "Ordernummer",
  "mypage.sampleRequest.detail.sellerDiscount": "Din säljare har satt {percent} % rabatt på hela beställningen.",
  "mypage.sampleRequest.detail.sentOn": "Skickad {date}",
  "mypage.sampleRequest.detail.itemsTitle": "Beställda artiklar",
  "mypage.sampleRequest.detail.units": "st",
  "mypage.sampleRequest.detail.withdraw": "Dra tillbaka",
  "mypage.sampleRequest.detail.delete": "Ta bort",
  "mypage.sampleRequest.detail.stepCreated": "Skapad",
  "mypage.sampleRequest.detail.stepSeller": "Godkänd av säljare",
  "mypage.sampleRequest.detail.stepCountry": "Godkänd av landschef",
  "form.invalid.formHasErrors": "Kontrollera fälten som är markerade ovan innan du fortsätter.",
  "mypage.sampleRequest.awaitingApproval": "Väntar på godkännande",
  "mypage.sampleRequest.needsChanges": "Behöver ändras",
  "mypage.sampleRequest.wasRejected": "Har varit avslagen",
  "mypage.sampleRequest.status.draft": "Utkast",
  "mypage.sampleRequest.status.awaiting_seller": "Väntar på säljare",
  "mypage.sampleRequest.status.awaiting_country": "Väntar på landschef",
  "mypage.sampleRequest.status.rejected_seller": "Avslagen till kund",
  "mypage.sampleRequest.status.rejected_country": "Avslagen till säljare",
  "mypage.sampleRequest.status.order": "Order skapad",
  "mypage.sampleRequest.tab.mine": "Att granska",
  "mypage.sampleRequest.tab.other": "Hos annan",
  "mypage.sampleRequest.tab.order": "Order skapad",
  "mypage.sampleRequest.tab.rejected": "Avslagna",
  "mypage.sampleRequest.tab.all": "Alla",
  "mypage.sales.sampleRequest": "Provbeställningar",
  "mypage.sales.sampleRequest.searchPlaceholder": "Sök kund, ort eller PB-nummer",
  "mypage.sales.sampleRequest.createNew": "Skapa ny",
  "mypage.sales.sampleRequest.of": "av",
  "mypage.sales.sampleRequest.createdLabel": "Skapat",
  "mypage.sales.sampleRequest.dateFrom": "Från",
  "mypage.sales.sampleRequest.dateTo": "Till",
  "mypage.sales.sampleRequest.dateRangeAny": "Valfritt datum",
  "mypage.sales.sampleRequest.datePreset30": "30 dagar",
  "mypage.sales.sampleRequest.datePreset90": "90 dagar",
  "mypage.sales.sampleRequest.datePreset1y": "1 år",
  "mypage.sales.sampleRequest.pickCustomerTitle": "Vilken kund gäller det här?",
  "mypage.sales.sampleRequest.backToList": "Provbeställningar ({count})",
  "mypage.sales.sampleRequest.contact": "Kontakt",
  "mypage.sales.sampleRequest.sent": "Skickad",
  "mypage.sales.sampleRequest.reference": "Referens",
  "mypage.sales.sampleRequest.approvedBySeller": "Godkänd av säljare",
  "mypage.sales.sampleRequest.approvedByCountryManager": "Godkänd av landschef",
  "mypage.sales.sampleRequest.itemsTitle": "Artiklar ({count} rader)",
  "mypage.sales.sampleRequest.itemsSubtitle": "Ändra antal, sätt radrabatt eller ta bort rader innan du godkänner.",
  "mypage.sales.sampleRequest.approveAsSeller": "Godkänn och skicka till landschef",
  "mypage.sales.sampleRequest.approveAsCountryManager": "Godkänn och skapa order",
  "mypage.sales.sampleRequest.reject": "Avslå",
  "mypage.sales.sampleRequest.rejectMessageLabel": "Meddelande till kunden om varför",
  "mypage.sales.sampleRequest.rejectConfirm": "Skicka avslag",
  "mypage.sales.sampleRequest.rejectCancel": "Avbryt",
  "mypage.sales.sampleRequest.rejectMessageRequired": "Ett meddelande krävs för att avslå en beställning.",
  "mypage.sales.sampleRequest.addItems": "Lägg till artiklar",
  "mypage.sales.sampleRequest.orderDiscountLabel": "Rabatt på hela beställningen",
  "mypage.sales.sampleRequest.applyOrderDiscount": "Applicera på alla rader",
  "mypage.sales.sampleRequest.itemCount": "{count} prover",
  "mypage.sales.sampleRequest.takeBack": "Ta tillbaka för redigering",
  "mypage.sales.sampleRequest.resubmit": "Skicka in på nytt till landschef",
  "mypage.sales.sampleRequest.checkoutTitle": "Leverans & checkout",
  "mypage.sales.sampleRequest.lockedForYou": "Beställningen är låst för dig.",
  "mypage.sales.sampleRequest.resetDiscount": "Nollställ",
  "mypage.sales.sampleRequest.freeFromPromotion": "Gratis från kampanj",
  "mypage.sales.sampleRequest.orderDiscountSaved": "{percent} % satt — kunden sparar {amount}",
  "mypage.sales.sampleRequest.messageToSeller": "Meddelande till säljaren",
  "mypage.sales.sampleRequest.messageToCustomer": "Meddelande till kunden",
  "mypage.sales.sampleRequest.messageToCountryManager": "Meddelande till landschef",
  "mypage.sales.sampleRequest.messageHelp": "Används både vid godkännande och avslag.",
  "mypage.sales.sampleRequest.toastApproved": "Godkänd — skickad till landschef",
  "mypage.sales.sampleRequest.toastOrderCreated": "Order skapad",
  "mypage.sales.sampleRequest.toastRejectedToSeller": "Avslag skickat till säljaren",
  "mypage.sales.sampleRequest.toastRejectedToCustomer": "Avslag skickat till kunden",
  "mypage.sales.sampleRequest.toastTakenBack": "Tillbaka hos dig för redigering",
  "mypage.sales.sampleRequest.toastResubmitted": "Skickad på nytt till landschefen",
  "mypage.orderProposal.acceptedFilter": "Godkända",
  "mypage.orderProposal.acceptedPartlyFilter": "Delvis godkända",
  "mypage.orderProposal.all": "Alla",
  "mypage.orderProposal.allStatuses": "Alla statusar",
  "mypage.orderProposal.allTypes": "Alla typer",
  "mypage.orderProposal.fromRequest": "Från förfrågan",
  "mypage.orderProposal.fromSeller": "Från säljare",
  "mypage.orderProposal.proposal": "Förslag",
  "mypage.orderProposal.request": "Förfrågan",
  "mypage.orderProposal.cartLoaded": "Varukorg hämtad – du redigerar nu orderförslag #{id} för kund {name}",
  "mypage.orderProposalHelp": "Nedan kan du se orderförslag som skickats till dig från säljare. Du kan välja att lägga hela orderförslaget i varukorgen och sedan redigera det om du vill.",
  "mypage.orderProposals": "Orderförslag",
  "mypage.orderProposal.declined": "Avvisat",
  "mypage.orderProposal.declinedFilter": "Avvisade",
  "mypage.orderProposal.delete": "Ta bort",
  "mypage.orderProposal.deleted": "Orderförslaget raderades",
  "mypage.orderProposal.draft": "Utkast",
  "mypage.orderProposal.edit": "Ändra",
  "mypage.orderProposal.emptyBasket": "Töm varukorg",
  "mypage.orderProposal.expired": "Utgått",
  "mypage.orderProposal.expiredFilter": "Utgångna",
  "mypage.orderProposal.greetings": "Mvh",
  "mypage.orderProposal.mergeBaskets": "Behåll varukorg",
  "mypage.orderProposal.mobile": "Förslag",
  "mypage.orderProposal.moreInfo": "Mer information",
  "mypage.orderProposal.options": "Mer",
  "mypage.orderProposal.order": "Godkänd",
  "mypage.orderProposal.partlyOrdered": "Delvis godkänd",
  "mypage.orderProposal.quantityText": "Visar {current} av {total} orderförslag",
  "mypage.orderProposal.salesRepOffer": "Erbjudande från din säljare, gäller vid köp av minst {num} st",
  "mypage.orderProposal.sent": "Skickad",
  "mypage.orderProposal.sentFilter": "Skickade",
  "mypage.orderProposal.showMoreCta": "Visa fler",
  "mypage.orderProposal.validUntil": "Orderförslaget gäller t.o.m.",
  "mypage.orderProposal.view": "Visa",
  "mypage.orderProposalAddToCart": "Lägg till i kundvagn",
  "mypage.orderProposalView": "Visa",
  "mypage.orderProposal.requestWaitingForSeller": "Väntar på säljare",
  "mypage.orderProposal.readyForReview": "Redo för granskning",
  "mypage.orderProposal.newRequest": "Ny förfrågan",
  "mypage.orderProposal.confirmDelete": "Är du säker på att du vill radera denna orderförslag?",
  "mypage.orderProposal.cancel": "Avbryt",
  "mypage.overview": "Översikt",
  "mypage.password.subheadline": "Mitt lösenord",
  "mypage.password.text": "Här kan du redigera ditt lösenord.",
  "mypage.rejectOrderProposal": "Avvisa orderförslag",
  "mypage.rejectOrderProposal.option.brands": "Fel varumärken",
  "mypage.rejectOrderProposal.option.notSpecify": "Vill inte ange",
  "mypage.rejectOrderProposal.option.other": "Annat",
  "mypage.rejectOrderProposal.option.price": "För dyrt",
  "mypage.rejectOrderProposal.option.requirements": "Uppfyller inte våra krav",
  "mypage.rejectOrderProposal.send": "Skicka",
  "mypage.rejectOrderProposal.text": "Välj en orsak till avvisat orderförslag",
  "mypage.rejectOrderProposal.writeHere": "Skriv här",
  "mypage.sales.confirmOrderproposalModalText": "Du har redan en aktiv varukorg med produkter i. Töm varukorgen för att fortsätta att redigera detta orderförslag.",
  "mypage.sales.customers": "Mina kunder",
  "invoices.table.download": "Ladda ner faktura",
  "minicart.summary.freight.b2c": "Frakt",
  "mypage.sales.sampleRequest.summaryTitle": "Summering",
  "mypage.sales.sampleRequest.summaryPriceBeforeDiscount": "Pris innan rabatt",
  "mypage.sales.dashboard": "Dashboard",
  "mypage.sales.favorites": "Favoriter",
  "mypage.sales.headline": "Säljverktyg",
  "mypage.sales.onboarding": "Om säljverktyget",
  "mypage.user.onboarding": "Om mina sidor",
  "mypage.sales.onboarding.close": "Stäng",
  "mypage.sales.onboarding.next": "Nästa",
  "mypage.sales.onboarding.progress": "Steg {activeIndex} av {totalSlides}",
  "mypage.sales.orderHistory": "Ordrar",
  "mypage.sales.orderProposal": "Orderförslag",
  "mypage.settings": "Inställningar",
  "mypage.settings.CustomerNo": "Kundnummer",
  "mypage.settings.address": "Mina leverans- och fakturauppgifter",
  "mypage.settings.address.text": "Här kan du som administratör redigera leverans- och faktureringsuppgifter för salongen",
  "mypage.settings.companyName": "Företag",
  "mypage.settings.orgNo": "Organisationsnummer",
  "mypage.settings.personal": "Mitt konto",
  "mypage.settings.personal.text": "Här kan du redigera dina personliga kontaktuppgifter.",
  "mypage.settings.subheadline": "Dina uppgifter",
  "mypage.settings.text": "Här kan du redigera dina uppgifter.",
  "mypage.tableHeader.created": "Skapad",
  "mypage.tableHeader.customerNr": "Kundnummer",
  "mypage.tableHeader.salon": "Butik",
  "mypage.tableHeader.status": "Status",
  "mypage.tableHeader.sum": "Totalsumma",
  "mypage.tableHeader.valid": "Giltighetstid",
  "mypage.tableHeader.basketId": "Order ID",
  "mypage.users.add": "Lägg till användare",
  "mypage.users.add.submit": "Bjud in",
  "mypage.users.add.success": "Användare med epost {email} har nu blivit inbjuden!",
  "mypage.users.delete": "Radera användare",
  "mypage.users.delete.confirm": "Är du säker på att du vill radera användaren? Åtgärden kan inte ångras.",
  "mypage.users.edit": "Redigera användare",
  "mypage.users.role.admin": "Administratör",
  "mypage.users.role.admin.about": "En admin har möjlighet att ändra vissa kontoinställningar, lägga beställningar och bjuda in nya användare till salongen.",
  "mypage.users.role.edit": "Behörighet",
  "mypage.users.role.finance": "Ekonomiansvarig",
  "mypage.users.role.finance.about": "Begränsad åtkomst. Kan bara hantera fakturor.",
  "mypage.users.role.user": "Användare",
  "mypage.users.role.user.about": "En användare kan endast lägga beställningar för företaget och kan inte ändra kontoinställningar.",
  "mypage.users.subheadline": "Användarkonton",
  "mypage.users.text": "Här kan du som administratör lägga till användare till företaget",
  "mypage.sampleInventory": "Prover",
  "mypage.sampleInventory.title": "Mina utställningar",
  "mypage.sampleInventory.emptyTitle": "Inga butiker hittades",
  "mypage.sampleInventory.emptySubTitle": "Du har inga butiker med utställningsprover att inventera.",
  "mypage.sampleInventory.storeName": "Butik",
  "mypage.sampleInventory.sampleCount": "{count} prover",
  "mypage.sampleInventory.lastInventory": "Senast inventerad",
  "mypage.sampleInventory.lastInventoried": "Senast inventerad",
  "mypage.sampleInventory.neverInventoried": "Aldrig inventerad",
  "mypage.sampleInventory.inventoried": "Inventerad",
  "mypage.sampleInventory.partiallyInventoried": "Delvis inventerad",
  "mypage.sampleInventory.notInventoried": "Ej inventerad",
  "mypage.sampleInventory.progress": "Inventeringens framsteg",
  "mypage.sampleInventory.progressCount": "{counted}/{total}",
  "mypage.sampleInventory.tabs.checklist": "Checklista",
  "mypage.sampleInventory.tabs.addSamples": "+ Lägg till prover",
  "mypage.sampleInventory.searchPlaceholder": "Sök bland prover...",
  "mypage.sampleInventory.infoBanner.title": "Så här fungerar inventeringen",
  "mypage.sampleInventory.infoBanner.text": "Markera de prover du har i din utställning genom att klicka i checkboxen. Saknas ett prov, klicka på krysset för att markera som saknad.",
  "mypage.sampleInventory.infoBanner.guideLink": "Storleksguide för prover",
  "mypage.sampleInventory.infoBanner.guideLinkUrl": "https://a.storyblok.com/f/316553/1532x6396/72362a97fc/sample-size-guide.png?cv=1781694017711",
  "mypage.sampleInventory.cancel": "Avbryt",
  "mypage.sampleInventory.submit": "Skicka inventering",
  "mypage.sampleInventory.success.title": "Inventering skickad",
  "mypage.sampleInventory.success.expected": "Förväntade prover",
  "mypage.sampleInventory.success.confirmed": "Bekräftade prover",
  "mypage.sampleInventory.success.missing": "Saknade prover",
  "mypage.sampleInventory.success.backButton": "Tillbaka till mina utställningar",
  "mypage.sampleInventory.addSamples.title": "Lägg till prover",
  "mypage.sampleInventory.addSamples.searchPlaceholder": "Sök produkt eller artikelnummer...",
  "mypage.sampleInventory.addSamples.emptySearch": "Inga produkter hittades",
  "mypage.sampleInventory.addSamples.noSamples": "Inga prover tillgängliga",
  "mypage.sampleInventory.addSamples.chooseSampleSize": "Välj provstorlek",
  "mypage.sampleInventory.addSamples.add": "Lägg till",
  "mypage.sampleInventory.addSamples.added": "Tillagd",
  "mypage.sampleInventory.backToStores": "Tillbaka till butiker",
  "mypage.sampleInventory.printPricelist": "Skriv ut prislista",
  "mypage.sampleInventory.downloadPricelist": "Ladda ner PDF",
  "mypage.sampleInventory.pricelistEmpty": "Inga golv med standardpris hittades för prislistan.",
  "mypage.sampleInventory.pricelistModal.confirmPrint": "Skriv ut",
  "mypage.sampleInventory.pricelistModal.confirmDownload": "Ladda ner",
  "mypage.sampleInventory.pricelistModal.subtitle": "{count} bekräftade golv · {store}",
  "mypage.sampleInventory.pricelistModal.pricing": "Prissättning",
  "mypage.sampleInventory.pricelistModal.modeDiscount": "Rabatt i procent",
  "mypage.sampleInventory.pricelistModal.modeCustom": "Egna priser",
  "mypage.sampleInventory.pricelistModal.generalDiscount": "Generell rabatt på hela sortimentet",
  "mypage.sampleInventory.pricelistModal.generalDiscountHint": "Gäller alla golv utan egen rabatt.",
  "mypage.sampleInventory.pricelistModal.exceptions": "Avvikande rabatt per golv",
  "mypage.sampleInventory.pricelistModal.clearExceptions": "Rensa undantag",
  "mypage.sampleInventory.pricelistModal.customHint": "Skriv in ert pris inkl. moms per golv. Tomt fält skriver ut rek. pris.",
  "mypage.sampleInventory.pricelistModal.resetAll": "Återställ alla",
  "mypage.sampleInventory.pricelistModal.colFloor": "Golv",
  "mypage.sampleInventory.pricelistModal.colRecommended": "Rek. pris",
  "mypage.sampleInventory.pricelistModal.colDiscount": "Rabatt",
  "mypage.sampleInventory.pricelistModal.colPrice": "Pris kr/m²",
  "mypage.sampleInventory.pricelistModal.colOwnPrice": "Ert pris kr/m²",
  "mypage.sampleInventory.pricelistModal.summaryDiscount": "{percent} % rabatt på {count} golv, {exceptions} golv med avvikande rabatt.",
  "mypage.sampleInventory.pricelistModal.summaryCustom": "{count} av {total} golv har eget pris. Golv utan standardpris skrivs bara ut om du anger ett eget pris.",
  "mypage.sampleInventory.expiredSample": "Detta prov har utgått, vänligen ta bort",
  "mypage.sampleInventory.verifyThisSample": "Kontrollera detta varuprov",
  "mypage.sampleInventory.missing": "Saknas",
  "newsletter.success": "Du har nu anmält dig till vårat nyhetsbrev",
  "notify.modal.button": "Starta bevakning",
  "notify.modal.text": "Ange din epost för att bevaka produkt",
  "notify.modal.title": "Bevaka produkt",
  "notify.openModalButton": "Bevaka",
  "order.articleNoPrefix": "Art. nr:",
  "order.history.active": "Aktiva",
  "order.history.all": "Alla ordrar",
  "order.history.cancel": "Avbrutna",
  "order.history.delivered": "Levererade",
  "order.item.count": "{count} st",
  "order.quantityPrefix": "Antal:",
  "order.quantityText": "Visar {current} av {total} ordrar",
  "order.repurchaseCta": "Handla igen",
  "order.showMoreCta": "Visa mer",
  "order.sizePrefix": "Storlek:",
  "order.status.allocation": "Mottagen - ordern är mottagen av Kährs",
  "order.status.allocation.short": "Mottagen",
  "order.status.backorder": "Ej levererad",
  "order.status.backorder.short": "Ej levererad",
  "order.status.cancelled": "Annullerad",
  "order.status.cancelled.short": "Annullerad",
  "order.status.confirmed": "Bekräftad - klar för att plockas",
  "order.status.confirmed.short": "Bekräftad",
  "order.status.created": "Skapad",
  "order.status.created.short": "Skapad",
  "order.status.customerSuccess": "Order lagd av: Kundtjänst",
  "order.status.delivered": "Levererades den {date}",
  "order.status.delivered.short": "Levererad",
  "order.status.deliveredNoDate": "Levererad",
  "order.status.deliveredNoDate.short": "Levererad",
  "order.status.invoiced": "Fakturerad",
  "order.status.partDelivered": "Delvis levererad - följ din order här",
  "order.status.partDelivered.short": "Dellevererad",
  "order.status.partDelivered.link": "Delvis levererad - <span class='underline cursor-pointer'>följ din order här</span>",
  "order.status.processing": "Behandlas - Förbereder leverans",
  "order.status.processing.short": "Behandlas",
  "order.status.reserved": "Order plockas - vi plockar och packar din order",
  "order.status.reserved.short": "Order plockas",
  "order.status.sales": "Order lagd av: Säljare",
  "order.status.sending": "På väg - Beräknad leverans: {date}",
  "order.status.sending.short": "På väg",
  "order.status.sendingNoDeliveryDate": "På väg",
  "order.status.sendingNoDeliveryDate.short": "På väg",
  "order.status.shipped": "Skickad - order påväg, följ din order här",
  "order.status.shipped.short": "Skickad",
  "order.status.shipped.link": "Skickad - order påväg, <span class='underline cursor-pointer'>följ din order här</span>",
  "order.status.track": "Spåra order",
  "order.title": "Orderhistorik",
  "order.title.mobile": "Ordrar",
  "orders.orderDate": "Beställningsdatum",
  "orders.orderNo": "Ordernummer",
  "orders.pending": "Det kan ta upp till 15 minuter innan lagda ordrar visas i listan",
  "orders.table.orderdate": "Beställningsdatum",
  "orders.table.ordernumber": "Ordernummer",
  "orders.table.priceSum": "Totalsumma ex moms",
  "orders.table.quanity": "Antal",
  "orders.table.status": "Status",
  "order.outOfStockModal.title": "Det gick inte att lägga alla varor i varukorgen",
  "order.outOfStockModal.text": "Följande varor finns antingen inte i lager eller inaktiva: {products}.",
  "order.outOfStockModal.hasActiveProductsText": "Vill du lägga resten som finns i lager i varukorgen?",
  "order.outOfStockModal.hasNoActiveProductsText": "Inga av varorna i den här ordern finns i lager eller är aktiva",
  "order.outOfStockModal.confirm": "Ja, lägg i varukorgen",
  "order.outOfStockModal.cancel": "Avbryt",
  "pointshop.checkout.tooltip": "Efter genomfört köp kan du handla backbars och testers för poängen",
  "pointshop.head.closingIn": "Ordern stängs om",
  "pointshop.head.continue": "Granska",
  "pointshop.head.noSelected": "Inga produkter valda",
  "pointshop.head.points": "{cur} av {max}",
  "pointshop.head.selectedPlur": "{num} produkter vald",
  "pointshop.head.selectedSingl": "1 produkt vald",
  "pointshop.head.toShopFor": "Poäng att handla för:",
  "pointshop.head.undo": "Rensa",
  "pointshop.product.isPoints": "Poängvara",
  "pointshop.product.showPoints": "{num} poäng",
  "pointshop.notEnough": "Du har inte tillräckligt med poäng",
  "pointshop.reminder": "Du har poäng att handla för.",
  "pointshop.reminder.click": "Klicka här",
  "price.exVat.short": "exkl. moms",
  "price.incVat.short": "inkl. moms",
  "price.notLoggedIn": "Logga in för att se pris",
  "priceInfo.discountLabel": "Rabatt",
  "priceInfo.loginForPriceInfo": "Logga in för att se pris",
  "priceInfo.financeUserTooltip": "Du kan inte slutföra köpet, kontakta kundservice",
  "priceInfo.shippingLabel": "Frakt",
  "priceInfo.totalPriceBeforeVat": "Delsumma exkl. moms",
  "priceInfo.totalPriceLabel": "Delsumma inkl. moms",
  "productList.autoNav.all": "Alla",
  "productList.empty.headline": "Här fanns inga produkter",
  "productList.empty.text": "Eventuellt har du inte tillgång till produkterna på denna sida. Kontakta oss om du är intresserad av att köpa detta sortiment",
  "productList.hide.content": "Göm content",
  "productList.priceHistory.lowest": "Lägsta pris {price}",
  "productList.product.hasVariants": "Finns i fler varianter",
  "productList.product.store.available": "Finns att se i butik",
  "productList.product.store.none": "Inte utställt i butik",
  "productList.product.store.distance": "Se i butik {distance} km bort",
  "productPage.bundles.btnText": "Köp paketet",
  "productPage.bundles.contains": "Paketet innehåller",
  "productPage.bundles.readAboutBundle": "Läs mer om paketet",
  "productPage.bundles.title": "Finns även i paket!",
  "productPage.extended.shade": "1 nyans",
  "productPage.extended.shades": "{num} nyanser",
  "productPage.extended.notLoggedIn": "Se pris",
  "productPage.faqModal.title": "FAQ",
  "productPage.favorites.text": "Du har inga favoriter. Klicka på hjärtat vid produkten om du vill spara den som din favorit.",
  "productPage.favorites.title": "Favoriter",
  "productPage.info.about": "Om produkten",
  "productPage.info.crossell": "Köps ofta tillsammans",
  "productPage.info.downloadDocs": "Ladda ner material",
  "productPage.info.guidesAndInspiration": "Guider och inspiration",
  "productPage.info.ingredients": "Ingredienser",
  "productPage.lastVisited.title": "Senast visade",
  "productPage.partNo": "Artikelnummer",
  "productPage.partNo.short": "Art.nr",
  "productPage.price.original": "Ord. pris",
  "productPage.price.yourDiscount": "din rabatt",
  "productPage.priceHistory.date": "Datum",
  "productPage.priceHistory.price": "Pris",
  "productPage.priceHistoryModal.title": "Prishistorik",
  "productPage.promotions.youSave": "Du sparar",
  "productPage.relatedProducts.addOns": "Tillbehör",
  "productPage.relatedProducts.colormaterial": "Material",
  "productPage.relatedProducts.fromBrand": "Upptäck mer från {brand}",
  "productPage.relatedProducts.relatedproducts": "Relaterade produkter",
  "productPage.relatedProducts.upsel": "Andra köpte också",
  "productPage.search.placeholder": "Sök namn, level eller artikelnummer",
  "productPage.similarProducts.title": "Liknande produkter",
  "productPage.sizeSelector.addToCartBtn": "Lägg i varukorgen",
  "productPage.sizeSelector.preOrder": "Förhandsboka",
  "productPage.sizeSelector.quantityLabel": "Antal",
  "productPage.sizeSelector.sizeGuideTitle": "Storleksguide",
  "productPage.sizeSelector.watchStockBtn": "Bevaka",
  "productPage.stockAlertError": "Det gick inte att bevaka produkten för tillfället. Försök igen senare!",
  "productPage.stockAlertPlaceholder": "Fyll i epost för att bevaka",
  "productPage.stockAlertSuccess": "Du bevakar nu den här produkten!",
  "productPage.stockAlertSuccessAgain": "Du bevakar redan den här produkten!",
  "productPage.truncateTextCtaClosed": "Läs mer",
  "productPage.truncateTextCtaOpen": "Läs mindre",
  "productPage.safetyInfo": "Safety Information",
  "quickbuy.button": "Lägg i varukorg",
  "search.brandSuggestion": "Varumärke",
  "search.cancel": "Stäng",
  "search.nohits": "Din sökning gav inget resultat",
  "search.page.headline": "Visar resultat för {search}",
  "search.page.hits.plur": "{num} träffar",
  "search.page.hits.sing": "1 träff",
  "search.page.others": "Övriga sidor",
  "search.page.othersHeadline": "Övriga sidor",
  "search.page.othersMissingHeadline": "Inga artiklar",
  "search.page.othersMissingText": "Tyävrr, inga artiklar finns här",
  "search.page.products": "Produkter",
  "search.pagetype.BrandPage": "Varumärke",
  "search.pagetype.page": "Sida",
  "search.placeholder": "Sök på produktnamn, kollektion eller artikelnummer",
  "search.popularProducts": "Populära produkter just nu",
  "search.showAll": "Visa alla sökträffar",
  "search.suggestions": "Sökförslag",
  "signin.emailPlaceholder": "E-postadress",
  "signin.forgot.button": "ÅTERSTÄLL LÖSENORD",
  "signin.forgot.confirmPasswordPlaceholder": "Bekräfta lösenord",
  "signin.forgot.confirmationText": "Om din e-post finns registrerad har vi nu skickat ett återställningsmail.",
  "signin.forgot.headline": "Välj ett nytt lösenord",
  "signin.forgot.setNew": "Spara nytt lösenord",
  "signin.forgot.success": "Ditt lösenord är nu uppdaterat. Du loggas automatiskt in inom kort.",
  "signin.forgot.text": "Ange din registrerade e-postadress för att återställa ditt lösenord.",
  "signin.forgot.title": "Återställ lösenord",
  "signin.forgotPassword": "Glömt ditt lösenord?",
  "signin.invoiceemailPlaceholder": "E-post för faktura",
  "signin.modalTitle": "Logga in",
  "signin.passwordPlaceholder": "Lösenord",
  "signin.signin": "Logga in",
  "signin.welcome.headline": "Slutför registreringen",
  "signin.welcome.justRegistered": "Välkommen till Kährs",
  "signin.welcome.justRegisteredText": "Ditt konto på Kährs har nu skapats och ett bekräftelsemail har skickats till din e-post. Klicka på länken i mailet för att ange ditt lösenord och logga in.",
  "signin.welcome.setNew": "Skapa konto och logga in",
  "signin.welcome.text": "Bestäm ett säkert lösenord till ditt konto för att slutföra registreringen och logga in!",
  "signup.complete": "Ditt konto skapades",
  "signup.complete.headline": "Hej, {name}!",
  "signup.complete.text": "Välkommen till Kährs",
  "signup.complete.toMyPage": "Gå till mina sidor",
  "signup.complete.toShopping": "Börja handla",
  "signup.cta": "Registrera intresse",
  "signup.error.passwordNoMatch": "Lösenorden matchar inte",
  "signup.error.passwordNoStrength": "Lösenordet måste vara 8 bokstäver",
  "signup.noAccount": "Inte kund än?",
  "signup.placeholder.careof": "c/o",
  "signup.placeholder.city": "Ort",
  "signup.placeholder.companyName": "Företagsnamn",
  "signup.placeholder.country": "Land",
  "signup.placeholder.email": "E-post",
  "signup.placeholder.firstName": "Förnamn",
  "signup.placeholder.lastName": "Efternamn",
  "signup.placeholder.newPass1": "Nytt lösenord",
  "signup.placeholder.newPass2": "Bekräfta nytt lösenord",
  "signup.placeholder.oldPass": "Nuvarande lösenord",
  "signup.placeholder.orgNo": "Organisationsnummer",
  "signup.placeholder.phone": "Telefonnummer",
  "signup.placeholder.street": "Adress",
  "signup.placeholder.street2": "Adress 2",
  "signup.placeholder.zip": "Postnummer",
  "signup.usp1": "Tillgång till exklusiva erbjudanden och kampanjer",
  "signup.usp2": "Snabbare och enklare betalningsprocess",
  "signup.usp3": "Notiser när dina favoriter är tillbaka i lager eller på rea",
  "siteName": "Kährs",
  "siteNotice.loggedInAs": "Inloggad som {name} ({id})",
  "siteNotice.changeSalon": "Byt kund",
  "siteNotice.changeSalon.customerSuccess": "Byt kund",
  "siteNotice.editingOrderProposal": "Redigerar orderförslag",
  "siteNotice.editingOrderProposalCustomer": "Den här varukorgen är skapad från ett orderförslag",
  "stock.backInStock": "Beräknat åter i lager {date}",
  "stock.cantAddMoreToCart": "Du kan inte lägga fler av den här varan i varukorgen då vi inte har tillräckligt i lager.",
  "stock.maxCanAdd": "Det går inte att lägga till fler än {num}",
  "stock.maxInCart": "Det går inte att lägga till fler än de du redan har i din varukorg",
  "stock.inStock": "Finns i lager",
  "stock.inStockSendWithinDays": "Finns i lager, hos dig inom 2-3 vardagar",
  "stock.sendWithin23Days": ", hos dig inom 2-3 vardagar",
  "stock.isOnDemandProduct": "Beställningsvara, skickas om {num} dagar",
  "stock.isOnDemandProductWithLineBreak": "Beställningsvara <br>skickas om {num} dagar",
  "stock.lowstock": "Vi har enbart {num} i lager",
  "stock.productHasExpired": "Produkten har utgått ur sortimentet",
  "stock.releaseDate": "Releasedatum {date}",
  "stock.releaseDateWithLineBreak": "Releasedatum <br>{date}",
  "stock.sendWithinDays": "Skickas inom {num} dagar",
  "stock.soldout": "Slut i lager",
  "stock.soldoutShort": "Slutsåld",
  "stock.tempDisabled": "Produken kan tyvärr inte köpas för tillfället",
  "stock.tempSoldout": "Tillfälligt slut i lager, beräknad åter {date}",
  "stock.tempSoldoutShort": "Tillfälligt slut",
  "events.loadMore": "Visar {current} av {total} events",
  "buyMore.inCheckout": "Rabatten appliceras i varukorgen.",
  "buyMore.saveAtleast.from": "Du sparar fr. {sum}",
  "buyMore.saveAtleast.exact": "Du sparar {sum}",
  "buyMore.perItem": "{sum}/st",
  "buyMore.steps": "Köp {buy} - få {get} extra gratis",
  "buyMore.nextCta.amount": "Lägg till {num} st",
  "buyMore.nextCta.percent": " - få {percent}% rabatt",
  "buyMore.plp.flag": "Köp fler, spara mer!",
  "buyMore.plp.gift-flag": "Gåva på köpet",
  "buyMore.multiCampaign-selectionHeadline": "Välj kampanj",
  "buyMore.multiCampaign-headline": "Köp fler, spara mer",
  "buyMore.multiCampaign-description": "Kampanjen tillämpas automatiskt i kassan",
  "buyMore.unique-headline": "Köp till ditt unika pris",
  "buyMore.gift-headline": "Gåva på köpet",
  "checkout.amount.more": "Fler",
  "checkout.gift": "Gåva",
  "productPage.extended.showAll": "Visa allt",
  "invoices.ledger.requested": "Reskontra begärd",
  "invoices.ledger.success": "Reskontra begärd, du kommer få ett mail med dina uppgifter inom ca tre arbetsdagar",
  "productPage.extended.variantNews": "Nyhet",
  "mypage.sales.fastOrder": "Power Order",
  "fastorder.table.partNo": "Art.nr.",
  "fastorder.table.brand": "Varumärke",
  "fastorder.table.name": "Produkt",
  "fastorder.table.num": "Antal",
  "fastorder.table.discount": "Rabatt %",
  "fastorder.table.priceStandard": "Pris std",
  "fastorder.table.priceUser": "Pris kund",
  "fastorder.table.margin": "Marginal %",
  "fastorder.table.total": "Totalsumma",
  "fastorder.upload": "Ladda upp CSV",
  "fastorder.upload.file": "Ladda upp fil",
  "fastorder.upload.text": "eller klistra in text:",
  "fastorder.upload.error": "Kunde inte läsa CSV. Kontrollera filen och försök igen",
  "fastorder.error.noFile": "Ingen fil vald",
  "fastorder.error.notTextFile": "Filen var inte en text fil",
  "fastorder.error.unknown": "Ett okänt fel inträffade. Kontrollera filen och försök igen",
  "fastorder.create": "Power Order",
  "fastorder.noCustomer": "Ingen kund vald",
  "fastorder.makePurchase": "Köp med faktura",
  "fastorder.searchPlaceholder": "Lägg till produkt genom att söka på artikelnummer eller namn…",
  "fastorder.changeSalon": "Byt kund",
  "fastorder.changeSalon.warning": "Varning!, byta kund raderar ordern.",
  "fastorder.changeSalon.cancel": "Avbryt",
  "fastorder.default": "Hantera order",
  "fastorder.clear": "Töm order",
  "fastorder.update": "Uppdatera",
  "fastorder.template.load": "Ladda mall",
  "fastorder.template.loadShort": "Ladda",
  "fastorder.template.delete": "Radera",
  "fastorder.template.save": "Spara mall",
  "fastorder.template.name": "Välj namn",
  "fastorder.template.replace": "Det finns redan en mall med det namnet. Den kommer skrivas över",
  "fastorder.showPreview": "Förhandsgranska",
  "fastorder.hidePreview": "Stäng förhandsvisning",
  "fastorder.preview.headline": "Förhandsgranska order",
  "fastorder.notGift": "Inte tillgänglig som gåva",
  "fastorder.duplicateLine": "Duplicera rad",
  "fastorder.summary": "Summering",
  "fastorder.gift": "Gåva",
  "fastorder.duplicateWarning.text": "Du har redan lagt till den här produkten i listan, vill du lägga till en till?",
  "fastorder.duplicateWarning.abort": "Avbryt",
  "fastorder.duplicateWarning.add": "Lägg till",
  "fastorder.templateMerge.text": "Vill du kombinera mallen med produkterna du redan lagt in i listan?",
  "fastorder.templateMerge.abort": "Nej, ersätt listan med min mall",
  "fastorder.templateMerge.add": "Ja, kombinera mallen och listan",
  "barcode.add": "Lägg till",
  "barcode.scan": "Skanna",
  "barcode.notFound": "Inget resultat: ",
  "barcode.popup.text": "Det finns funna produkter du inte än lagt till i listan, är du säker på att du vill stänga?",
  "barcode.popup.close": "Jag är säker, stäng.",
  "barcode.popup.continue": "Jag vill fortsätta",
  "stock.std.over100": "Över 100 på lager",
  "stock.std.over50": "Över 50 på lager",
  "stock.std.over25": "Över 25 på lager",
  "stock.std.less25": "Färre än 25 på lager",
  "stock.alt.over5": "Över 5 på lager",
  "stock.alt.less5": "Färre än 5 på lager",
  "product.recommendedPrice.short": "Bruttopris",
  "productPage.bundles.showAll": "Visa hela innehållet ({num})",
  "productPage.bundles.showLess": "Dölj",
  "flag.new": "Nyhet",
  "flag.sale": "Nersatt pris",
  "checkout.order.company": "Ordern läggs för företag {company}",
  "checkout.additionalInformation": "Extra information",
  "checkout.additionalInformation.comment": "Kommentar",
  "checkout.additionalInformation.invoiceNotice": "Fakturamärkning",
  "order.invoiceNotice.label": "Fakturamärkning",
  "fastorder.table.hiddenProduct": "Detta är en produkt som inte visas ute på sidan",
  "fastorder.max_quantity_reached": "Max antal tillagt i varukorgen",
  "checkout.addDiscountModal.description": "Välj hur många {name} du vill lägga till i ordern och hur mycket rabatt det ska vara på produkten.",
  "fastorder.fromPromotion": "{num} st från kampanj",
  "fastorder.freeFromPromotion": "Gratis från kampanj",
  "fastorder.fromPromotion.headline": "Gåvor",
  "fastOrder.row.user_pricelist": "Användarens prislista",
  "fastOrder.row.std_pricelist": "Standard prislista",
  "fastOrder.row.promotion_available": "promotion tillgänglig",
  "fastOrder.row.no_promotion_available": "ej promotion",
  "order.cancel": "Makulera order",
  "order.cancel.warning": "Är du säker på att du vill makulera denna order?",
  "order.cancel.confirm": "Ja, makulera",
  "order.cancel.successMessage": "Ordern makulerades",
  "order.edit.warning": "Är du säker på att du vill redigera denna order?",
  "order.edit.confirm": "Ja, redigera",
  "order.edit.successMessage": "Ordern är tillagd i varukorgen och kan redigeras.",
  "stock.sendWhenInStock": "Skicka så fort den är i lager",
  "crossDocking.shipping": "Extraleverans",
  "account.emptyBackorder.title": "Inga backorders",
  "account.emptyBackorder.subTitle": "Inga backorders description",
  "checkout.backorder.sendWhenInStock": "Denna vara skickas i en separat försändelse så fort den inkommer i lager",
  "product.backorderNotice": "OBS! Du har redan lagt en beställning av {quantity} st som ännu inte levererats till dig.",
  "product.backorderNoticeWithDate": "OBS! Du har redan lagt en beställning av {quantity} st som ännu inte levererats till dig. Redo att skickas {date}",
  "productPage.buybox.confirmBackorderTitle": "OBS! Produkten är tillfälligt slut i lager och är beräknad åter {date}.",
  "productPage.buybox.confirmBackorderContentFirst": "Du kan fortfarande genomföra köpet men produkten kommer skickas med din nästa beställning.",
  "productPage.buybox.confirmBackorderContentSecond": "I varukorgen kan du kryssa i en checkbox för att få produkten skickade när det åter är i lager för en extra fraktkostnad på 69 kr",
  "fastorder.noRows": "Inga tillagda produkter",
  "fastOrder.noTemplates": "Du har inga sparade mallar",
  "siteNotice.editingOrder": "Redigerar order",
  "order.replacingOrder": "Ersätter order #{orderId}",
  "articles.keyword.Floors": "Golv",
  "checkout.customAddressConsumer": "Skicka till konsument",
  "price.exVat.shown": "Priser visas exkl. moms",
  "price.incVat.shown": "Priser visas inkl. moms",
  "productPage.productFacts": "Produktfakta",
  "discountBreakpoint": "{percent}% - Köp {num}+ paket",
  "units.package.short": "pkt",
  "areaConvert.disclaimer": "Kährs och installatörer rekommenderar att man räknar med 5 % extra kvadratmeter på grund av spill vid installation.",
  "areaConvert.packageEquals": "1 paket = {areaPerPackage}{unitDisplay}",
  "areaConvert.inputArea.placeholder": "Enter {unitDisplay}",
  "areaConvert.pricePerPack": "Pris/Paket {price}",
  "checkout.invoice.deliveryAddress": "Leveransadress",
  "productPage.downloads": "Bilder och filer",
  "productPage.downloads.disclaimer": "Alla prover, bilder och produktbeskrivningar samt specifikationer i broschyrer och foton är enbart avsedda att ge en ungefärlig uppfattning om produkterna. De utgör inte någon del av avtalet och har ingen juridiskt bindande verkan, utan ska enbart ses som illustrativa exempel.\n\nVi kan inte garantera att färgåtergivningen på din skärm eller utskriftskvaliteten exakt återger produktens faktiska färg. Den levererade produkten kan därför avvika något från bilderna i detta material.",
  "accessories.headline": "Matchande tillbehör",
  "accessories.showMore": "Visa alla matchande ({num})",
  "checkout.delivery.poNumber.title": "PO-nummer eller märkning",
  "checkout.delivery.poNumber.tooltip": "Vad du vill märka din order med",
  "checkout.delivery.shippingAdvice.title": "Leveransinstruktioner",
  "checkout.delivery.shippingAdvice.tooltip": "Fyll i nödvändig information för vår speditör",
  "checkout.delivery.tooltip": "Fyll i din önskade leveransadress",
  "checkout.trackTrace.title": "Track & Trace",
  "checkout.trackTrace.customerInfo": "Mottagarinformation",
  "checkout.trackTrace.trackingType": "Hur vill du få din spårningslänk?",
  "checkout.trackTrace.trackingType.email": "Spårningslänk skickas till en e-postadress.",
  "checkout.trackTrace.trackingType.sms": "Spårningslänk skickas via SMS till ett telefonnummer.",
  "checkout.trackTrace.trackingType.both": "Spårningslänk skickas både till e-post och via SMS.",
  "checkout.consumerShippingFee": "500 SEK",
  "stock.futuredelivery": "{num} finns i lager {date}",
  "samples.cta": "Beställ varuprov",
  "stock.area.less250": "{area} {unit} på lager",
  "stock.area.more250": "250+ {unit} på lager",
  "stock.area.more500": "500+ {unit} på lager",
  "stock.area.more1000": "1000+ {unit} på lager",
  "stock.area.more2500": "2500+ {unit} på lager",
  "header.switchTo.b2c": "Privatperson",
  "header.switchTo.b2b": "Företag",
  "stock.isOnDemandProduct.unknownDelivery": "Beställningsvara",
  "stock.noFutureAvaliability": "Ingen framtida produktion planerad. Kundtjänst kommer kontakta dig efter ordern är lagd",
  "checkout.trackTrace.contact": "Kundkontakt",
  "checkout.trackTrace.trackingType.email.label": "Email",
  "checkout.trackTrace.trackingType.sms.label": "SMS",
  "checkout.trackTrace.trackingType.both.label": "Båda",
  "checkout.selectPayer.placeholder": "Välj vilken person hos kunden som ska stå som referens",
  "checkout.orderProposal.selectCustomer": "Välj kund",
  "stock.soldout.or": " eller ",
  "stock.soldout.hasRelated": "Se liknande produkter",
  "stock.soldout.contactSupport": "Kontaka kundtjänst",
  "checkout.trackTrace.invalidPhone": "Ogiltigt format",
  "checkout.crossSell.relatedTo": "Relaterad till",
  "checkout.delivery.samples": "Skickas så fort som möjligt",
  "areaConvert.total": "Total: ",
  "orderProposal.comparison.customerCart": "Kunden köpte",
  "areaConvert.package": "paket",
  "checkout.shipping.free": "Gratis",
  "fastOrder.globalDiscount": "Global rabatt",
  "fastOrder.globalDiscount.description": "Denna inställning sätter samma rabattsats på alla rader i ordern",
  "form.invalid.date": "Ogiltigt datum",
  "form.invalid.positiveNumber": "Måste vara ett nummer över 0",
  "claims.new.headline": "Skapa ny reklamation",
  "claims.new.submit": "Skicka in reklamation",
  "claims.searchAccount": "Sök Kundnummer",
  "claims.Customernumber": "Kundnummer *",
  "claims.ContactName": "Namn *",
  "claims.ContactEmail": "E-post *",
  "claims.ContactPhone": "Telefon",
  "claims.Date": "Datum för anmälan",
  "claims.OrderNumber": "Kährs order- eller fakturanummer *",
  "claims.InstallationPerformedBy": "Installation utförd av",
  "claims.InstallationPerformedBy.options": "Konsument;Hantverkare;Ej lagt",
  "claims.InstallationType": "Installationstyp",
  "claims.IT.option1": "Flytande Installation:5",
  "claims.IT.option2": "Nedlimmad:4",
  "claims.IT.option3": "Inte installerat:925410000",
  "claims.IT.option4": "Inte valt:100000000",
  "claims.ConsumerName": "Konsumentens namn *",
  "claims.ConsumerAddress": "Konsumentens adress *",
  "claims.ConsumerPostcode": "Konsumentens postnummer *",
  "claims.ConsumerCity": "Konsumentens stad *",
  "claims.ConsumerCellphone": "Konsumentens telefonnummer *",
  "claims.ConsumerEmail": "Konsumentens e-post",
  "claims.ConsumerDeliveryInstructions": "Övrig information",
  "claims.DateOnRecipt": "Inköpsdatum på konsumentens kvitto",
  "claims.Receipt": "Kvitto visat för återförsäljaren? *",
  "claims.CustomerClaimNo": "Återförsäljarens ärendenummer",
  "claims.MainReasonOption": "Reklamerat fel *",
  "claims.MR.option1": "Lövspricka:140100006",
  "claims.MR.option2": "Spricka:140100007",
  "claims.MR.option3": "Öppen eller urfallen kvist:140100008",
  "claims.MR.option4": "Stavsläpp:140100022",
  "claims.MR.option5": "Utseendefråga:140100025",
  "claims.MR.option6": "Intrycksmärke:100000000",
  "claims.MR.option7": "Tillbehör:925410005",
  "claims.MR.option8": "Fogsprång/nivåskillnad långsida:140100014",
  "claims.MR.option9": "Fogsprång/nivåskillnad kortsida:140100015",
  "claims.MR.option10": "Missljud/knarr:140100029",
  "claims.MR.option11": "Konvex bräda:140100030",
  "claims.MR.option12": "Konkav bräda:140100031",
  "claims.MR.option13": "Övrigt fel:140100033",
  "claims.ClaimError": "Beskriv fel *",
  "claims.ArticleNumber": "Artikelnummer *",
  "claims.searchArticleNumber": "Sök artikelnummer",
  "claims.ProductName": "Produktnamn",
  "claims.DeliveredQuantity": "Total installerad yta (m², styck eller lpm) *",
  "claims.ClaimedQuantity": "Antal reklamerad yta (m², styck eller lpm) *",
  "claims.InstallationDate": "När är produkten installerad (år/månad) *",
  "claims.DefectDiscovered": "När upptäcktes felet? (år/månad) *",
  "claims.RoomType": "Vilken typ av utrymme/rum ligger det reklamerade golvet i?",
  "claims.RT.option1": "Vardagsrum",
  "claims.RT.option2": "Matsal",
  "claims.RT.option3": "Kök",
  "claims.RT.option4": "Sovrum",
  "claims.RT.option5": "Hall",
  "claims.RT.option6": "Allrum",
  "claims.RT.option7": "Annat utrymme (ange under kompletterande information nedan)",
  "claims.FloorHeating": "Golvvärme *",
  "claims.FloorHeating.options": "Nej;El;Vattenburen",
  "claims.FloorConstruction": "Undergolvskonstruktion *",
  "claims.FloorConstruction.options": "Gjutet på platta; Krypgrund; Träbjälklag; Bettongbjälklag; Annan (ange under kompletterande information nedan)",
  "claims.UnderFloorMaterial": "Undergolvsmaterial",
  "claims.UnderFloorMaterial.options": "Skivmaterial (trä/gips); Flytspacklat; EPS; Betong; Annat (ange under kompletterande information nedan)",
  "claims.SubfloorMaterial": "Mellanlägg *",
  "claims.SubfloorMaterial.options": "Kährs Tuplex; Kährs kombifoam; Kährs foam; Annat (ange under kompletterande information nedan)",
  "claims.VaporBarierInstalled": "Är ångspärr installerad? *",
  "claims.ExpansionGap": "Finns rörelsefog enl. läggningsanvisning? *",
  "claims.OilingPerformed": "Vid oljat golv, är installationsoljning utförd?",
  "claims.EndJointOffset": "Finns korrekt kortändsförskjutning? *",
  "claims.ProfilingDate": "Stämpel på brädans baksida (datum + tid)",
  "claims.LabelNo": "Etikettnummer",
  "claims.HumidityInRange": "Är luftfuktigheten inom 30-60 % RF?",
  "claims.UnderfloorTolerances": "Uppfyller undergolvet rätt toleranser? *",
  "claims.AdditionalInformation": "Kompletterande information",
  "order.status.invoiced.short": "Fakturerad",
  "claims.old.headline": "Tidigare reklamationer",
  "claims.old.none": "Inga tidigare reklamationer",
  "claims.table.caption": "Reklamationsärenden",
  "claims.tableCol.ticketNumber": "Ärendenummer",
  "claims.tableCol.title": "Titel",
  "claims.tableCol.stage": "Steg",
  "claims.tableCol.status": "Status",
  "claims.tableCol.createdDate": "Skapad datum",
  "claims.tableCol.closedDate": "Stängd datum",
  "form.placeholder.name": "Namn",
  "claims.new.success": "Din reklamation har blivit registrerad",
  "stock.apiError": "Det gick inte att ladda lagerstatus, visad siffra kan vara fel",
  "stock.expiring": "Produkten upphör, ingen framtida produktion planerad.",
  "stock.expiring.max": "Produkten upphör, du kan max köpa {num}{unit}",
  "stock.std.exact": "{num} på lager",
  "claims.tableCol.product": "Produkt",
  "findRetailer.currentLocation": "Använd min nuvarande position",
  "findRetailer.hasDisplaySamples": "Har utställningsprov",
  "findRetailer.hasNoDisplaySamples": "Har inte utställningsprov",
  "findRetailer.searchPlaceholder": "Sök efter postnummer eller stad",
  "findRetailer.bookApointment": "Boka ett möte",
  "findRetailer.filter.title": "Filter",
  "findRetailer.filter.sort": "Sortera efter",
  "findRetailer.filter.distance": "Distans",
  "findRetailer.filter.exhibitionSize": "Storlek på utställning",
  "findRetailer.filter.exhibition": "Utställning",
  "findRetailer.filter.floorTypes": "Golvtyper",
  "findRetailer.filter.clearFilter": "Rensa",
  "findRetailer.filter.applyFilter": "Visa {num} återförsäljare",
  "findRetailer.retailerDistance": "Distans: {num} km",
  "findRetailer.noResults.title": "Ingen återförsäljare hittad",
  "findRetailer.noResults.message": "Vi kunde inte hitta några återförsäljare som matchar din filtrering",
  "findRetailer.noResults.clearFilters": "Rensa filter",
  "findRetailer.tabs.mapView": "Kartvy",
  "findRetailer.tabs.listView": "Listvy",
  "findRetailer.load.quantityText": "{current} av {total} återförsäljare",
  "findRetailer.load.showMoreCta": "Visa mer",
  "mypage.selectCustomer": "Välj kund",
  "retailer.form.title": "Boka en konsultationstid",
  "retailer.form.name": "Namn",
  "retailer.form.email": "E-post",
  "retailer.form.phone": "Telefon",
  "retailer.form.date": "Önskat datum för möte",
  "retailer.form.message": "Meddelande...",
  "retailer.form.checkbox": "Jag accepterar",
  "retailer.form.checkboxLink": "Villkor",
  "retailer.form.cta": "Boka tid",
  "retailer.contact.emailTitle": "E-post",
  "retailer.contact.phoneTitle": "Telefon",
  "retailer.contact.locationTitle": "Plats",
  "retailer.contact.locationDirections": "Få vägbeskrivning",
  "retailer.contact.websiteTitle": "Webbsida",
  "retailer.contact.websiteVisit": "Besök webbsida",
  "checkout.upsell.underlays": "Underlag",
  "checkout.upsell.accesories": "Tillbehör",
  "checkout.upsell.aftercare": "Underhåll & reperation",
  "checkout.upsell.installation": "Installation och verktyg",
  "stock.std.less5": "Färre än 5 i lager",
  "articles.keyword.News": "Nyheter",
  "articles.keyword.Guides": "Guider",
  "articles.keyword.Inspiration": "Inspiration",
  "pdp.breadcrumbs.allProducts": "Alla produkter",
  "claims.image.addComment": "Lägg till en kommentar",
  "claims.image.required": "Lägg till åtminstone 2 bilder",
  "priceInfo.yourDiscount.percent": "Rabatt: ",
  "floorFinder.step": "Steg {currentStep} av {totalSteps}",
  "floorFinder.reset": "Återställ",
  "floorFinder.floorsFound": "golv funna",
  "floorFinder.previous": "Föregående",
  "floorFinder.next": "Nästa steg",
  "floorFinder.complete": "Se ditt resultat",
  "floorFinder.mailMe": "Mejla mig ditt resultat",
  "order.quantityPrefix.total": "Totalt antal:",
  "order.quantityPrefix.added": "Antal tillagt:",
  "form.send": "Skicka",
  "form.required": "Obligatoriskt",
  "accessories.headline.b2c": "Rekommenderade tillbehör",
  "accessories.text.b2c": "Kährs är mycket mer än bara golv. För varje golv vi erbjuder kan du hitta en komplett kollektion av tillbehör, inklusive underlag, avslutningsprofiler och golvsocklar som perfekt matchar färgen på ditt golv.",
  "samples.b2c.free": "Beställ gratis prov",
  "samples.b2c.available": "Gratis prov tillgängligt",
  "samples.b2b.orderSample": "Beställ prov",
  "findRetailer.rating1.name": "Mindre utställning",
  "findRetailer.rating1.description": "Prover på 12-24 produkter. Har inget eget lager.",
  "findRetailer.rating2.name": "Stor utställning",
  "findRetailer.rating2.description": "Prover på 24-48 produkter inkl. stora prover. Har egen lagerhållning. Personalen har god kunskap om Kährs produkter.",
  "findRetailer.rating3.name": "Större utställning",
  "findRetailer.rating3.description": "Mer än 48 prover på produkter inkl. stora prover. Har egen lagerhållning inkl. tillbehör. Personalen har mycket god kunskap om Kährs produkter.",
  "findRetailer.rating4.name": "Komplett utställning",
  "findRetailer.rating4.description": "Näst intill komplett sortiment av prover. Har egen lagerhållning inkl. tillbehör. Personalen har mycket god kunskap om Kährs produkter.",
  "findRetailer.kind.wood": "Trägolv",
  "findRetailer.kind.resilient": "Vinylgolv",
  "findRetailer.link": "Hitta återförsäljare",
  "floorFinder.mailMe.text": "Ange din e-postadress för att få ditt resultat skickat till dig",
  "floorFinder.mailed": "Ditt resultat har blivit skickat",
  "floorFinder.acceptContact": "Jag vill få nyheter & uppdateringar via e-post.",
  "personality.headline": "Personlighet",
  "personality.features": "Nyckelfunktioner",
  "dyn.personality.Character.min": "Rent & Modernt",
  "dyn.personality.Character.max": "Uttrycksfullt",
  "dyn.personality.Maintenance.min": "Installera & njut",
  "dyn.personality.Maintenance.max": "Extra kärlek",
  "dyn.personality.SunExposure.min": "För evigt ung",
  "dyn.personality.SunExposure.max": "Bygger karaktär över tid",
  "dyn.personality.VisualFinish.min": "Ultramatt",
  "dyn.personality.VisualFinish.max": "Satin",
  "dyn.personality.Installation.min": "Enkelt att fixa själv",
  "dyn.personality.Installation.max": "Professionellt",
  "dyn.personality.Durability.min": "Idealiskt för hög trafik (hall, kök, gemensamma utrymmen)",
  "dyn.personality.Durability.max": "Låg trafik (sovrum, hemmakontor)",
  "anchorlink.headline": "Snabbt hopp till",
  "anchorlink.personality": "Personlighet",
  "anchorlink.recommendedAccessories": "Rekommenderade tillbehör",
  "anchorlink.colour": "Färg",
  "anchorlink.material": "Material",
  "anchorlink.facts": "Fakta",
  "anchorlink.documents": "Dokument",
  "anchorlink.faq": "Vanliga frågor",
  "plannerPromo.tagline": "Floor planner",
  "plannerPromo.headline": "Se golvet i vår Floor planner",
  "plannerPromo.text": "Visualisera {productName} i ditt hem med vår interaktiva floor planner. Prova olika inställningar och belysning för att hitta den perfekta matchningen för din stil.",
  "plannerPromo.buttonText": "Visualisera i floor planner",
  "floorPlanner.headline1": "Välkommen till",
  "floorPlanner.headline2": "Kährs Floor planner",
  "floorPlanner.iframeTitle": "Golvplanerare — välj golv och rum",
  "floorPlannerSelector.tab.wood": "Trägolv",
  "floorPlannerSelector.tab.vinyl": "Vinyl & vinylfritt golv",
  "floorPlannerSelector.color": "Färg",
  "floorPlannerSelector.filter": "Filter",
  "floorPlannerSelector.showFewerFilters": "Visa färre filter",
  "floorPlannerSelector.showMoreFilters": "Visa fler filter",
  "floorPlannerSelector.resetFilters": "Återställ filter",
  "floorPlannerSelector.search": "Sök",
  "floorPlannerSelector.grouping.construction": "Konstruktion",
  "floorPlannerSelector.grouping.collection": "Kollektioner",
  "floorPlannerSelector.viewProduct": "Visa produkt",
  "floorPlannerSelector.quickbuy": "Snabbköp",
  "quickbuy.button.inCart": "Redan i kundvagnen - gå till kassan",
  "findRetailer.bookAppointment": "Boka ett möte",
  "findRetailer.quickbox.headline": "Hitta återförsäljare",
  "findRetailer.quickbox.text": "Besök en av våra återförsäljare för att uppleva våra golv i verkligheten",
  "findRetailer.findbutton": "Hitta återförsäljare",
  "checkout.terms.mandatory": "Obligatorisk",
  "checkout.terms.optional": "Valfritt",
  "checkout.b2c.terms.header": "Jag bekräftar att leverans av prover sker i befintligt skick, utan något ansvar från Kährs sida och utan åtagande gällande leveranstid.",
  "checkout.b2c.terms.terms1": "Jag har läst och bekräftar att denna tjänst har begärts av mig som konsument, och att även om proverna levereras i befintligt skick, påverkas inte mina konsumenträttigheter. Provbeställningar skickas elektroniskt till vår lokala partner för leverans per post.",
  "checkout.b2c.terms.terms2": "JAG ÄR EN KONSUMENT – Jag samtycker till att bli kontaktad.\nJag godkänner att mina kontaktuppgifter delas med en auktoriserad återförsäljare, som kan kontakta mig för att diskutera min provbeställning och relaterade produkter. Jag förstår att detta är frivilligt och att jag endast kommer att bli kontaktad om jag ger mitt uttryckliga samtycke genom att kryssa i denna ruta. Mer om <a href=\"https://www.kahrs.com/se/juridisk-information\" target=\"_blank\" class=\"underline\">Kährs integritetspolicy</a>",
  "checkout.b2c.terms.terms3": "Jag vill inte bli kontaktad av Kährs eller någon återförsäljare.",
  "checkout.b2b.terms.terms1": "Jag bekräftar att jag har läst och godkänner villkoren för provbeställning.",
  "checkout.b2b.terms.terms2": "Jag godkänner att mina uppgifter behandlas enligt Kährs integritetspolicy.",
  "form.invalid.futureDate": "Måste vara ett datum i framtiden",
  "price.exVat.rec": "Bruttopris (exkl. moms)",
  "price.incVat.rec": "Rek. pris (inkl. moms)",
  "checkout.b2c.deliveryHeadline": "Leverans",
  "form.placeholder.email.short": "E-post",
  "retailer.form.success": "Din förfrågan har skickats. Vi kommer att kontakta dig",
  "checkout.b2c.additionalComments": "Ytterligare kommentarer",
  "checkout.b2c.additionalComments.placeholder": "Skriv en kommentar här...",
  "checkout.b2bSample.heading": "Företagsinformation",
  "checkout.b2bSample.companyName": "Företagsnamn",
  "checkout.b2bSample.companyNamePlaceholder": "Ange företagsnamn...",
  "checkout.b2bSample.projectDescription": "Projektbeskrivning",
  "checkout.b2bSample.projectDescriptionPlaceholder": "Skriv en beskrivning här...",
  "checkout.b2bSample.role": "Roll",
  "checkout.b2bSample.rolePlaceholder": "Roll",
  "checkout.b2bSample.roleArchitect": "Arkitekt",
  "checkout.b2bSample.roleContractor": "Entreprenör",
  "checkout.b2bSample.roleInteriorDesigner": "Inredningsdesigner",
  "checkout.b2bSample.roleOther": "Annan",
  "order.shipDatePrefix": "Skickas:",
  "orders.table.poNumber": "PO-nummer",
  "orders.table.tracking": "Spårning",
  "priceInfo.discountType.percentage": "Procentuell rabatt",
  "priceInfo.discountType.fixedPerM2": "Fast pris per m²",
  "priceInfo.fixedDiscountPerM2": "Pris per m²",
  "checkout.shippingStartOver": "Ändra",
  "b2b.wrongPage": "Du tittar på sidan för konsumenter",
  "b2b.switchPage": " - för att se denna sida för handelsparter, <u>Klicka här</u>",
  "b2c.wrongPage": "Du tittar på sidan för handelspartners",
  "b2c.switchPage": " - för att visa denna sida för våra handelspartners, <u>Klicka här</u>",
  "articles.keyword.hospitalitywood": "Hotell & Restaurang",
  "articles.keyword.publicspaceswood": "Offentliga utrymmen",
  "articles.keyword.retailwood": "Detaljhandel",
  "articles.keyword.residentialwood": "Bostadsområden",
  "articles.keyword.retaillt": "Detaljhandel",
  "articles.keyword.hospitalitylt": "Hotell",
  "articles.keyword.sportfacilitieslt": "Idrottsanläggningar",
  "articles.keyword.officelt": "Kontor",
  "articles.keyword.otherlt": "Andra",
  "articles.keyword.healthcare": "Hälso- och sjukvård",
  "articles.keyword.officewood": "Kontor",
  "articles.keyword.daycare": "Förskola",
  "articles.keyword.education": "Skola och utbildning",
  "user.impersonateToAddToCart": "Du måste logga in som ett företag för att lägga till i varukorgen",
  "accessories.relationTypes.Mouldings": "Lister",
  "accessories.relationTypes.Skirtings": "Socklar",
  "accessories.relationTypes.Profiles": "Profiler",
  "accessories.relationTypes.Aftercare": "Underhåll & Reparationsprodukter",
  "accessories.relationTypes.Samples": "Prover",
  "accessories.relationTypes.Underlays": "Underlag",
  "accessories.relationTypes.Installation": "Installation",
  "resilient.disclaimer": "För att köpa dessa produkter, vänligen kontakta vårt säljteam för hjälp",
  "resilient.contactSales": "Kontakta vårt säljteam",
  "resilient.contactSalesEmail": "sales@kahrs.com",
  "mypage.tableHeader.type": "Typ",
  "mypage.tableHeader.source": "Källa",
  "mypage.tableHeader.actions": "Åtgärder",
  "mypage.tableHeader.items": "Artiklar",
  "productPage.requestOrderProposalButton": "Begär offert",
  "productPage.requestOrderProposalDescription": "Du kvalificerar dig för ett anpassat förslag. Lägg till i kundvagn och begär pris från försäljning.",
  "request.orderProposal.title": "Offertförfrågan",
  "request.orderProposal.company": "Företag",
  "request.orderProposal.requestDate": "Förfrågningsdatum",
  "request.orderProposal.message": "Meddelande",
  "request.orderProposal.powerOrder": "Redigera i Power Order",
  "request.orderProposal.customer": "Kund",
  "request.orderProposal.validity": "Giltighet",
  "request.orderProposal.response": "Svar",
  "request.orderProposal.generatedResponse": "Genererat svar",
  "request.orderProposal.edit": "Redigera",
  "request.orderProposal.cancel": "Avbryt",
  "request.orderProposal.save": "Spara",
  "request.orderProposal.products": "Produkter",
  "request.orderProposal.discountPercent": "Sätt % rabatt per artikel",
  "request.orderProposal.discountCustom": "Anpassad",
  "request.orderProposal.fixedPrice": "Nettopris",
  "request.orderProposal.sendCta": "Skicka orderförslag",
  "request.orderProposal.proposalDetails": "Förslagsdetaljer",
  "request.orderProposal.summary": "Sammanfattning",
  "request.orderProposal.quantity": "Kvantitet",
  "request.orderProposal.changeUserWarning": "Alla osparade ändringar i nuvarande kundvagn kommer att förloras om du fortsätter.",
  "request.orderProposal.changeUserConfirm": "Fortsätt",
  "request.orderProposal.changeUserCancel": "Avbryt",
  "request.orderProposal.fromRequest": "Från förfrågan",
  "request.orderProposal.fromSeller": "Från säljare",
  "request.orderProposal.rejectRequest": "Avvisa förfrågan",
  "request.orderProposal.yourMessageToSeller": "Ditt meddelande till säljare",
  "request.orderProposal.createdOn": "Skapad den",
  "request.orderProposal.validUntil": "Giltig till",
  "request.orderProposal.source": "Källa",
  "request.orderProposal.sellerProposalMessage": "Här är ett orderförslag baserat på din förfrågan.",
  "checkout.delivery.enterNumber": "Ange nummer...",
  "checkout.item.extraComments": "Extra kommentarer",
  "checkout.palletDiscount": "Rabatt tillämpas när 4 eller fler pallar golv beställs",
  "mypage.carts": "Varukorgar",
  "mypage.carts.filter.year": "År",
  "mypage.carts.created": "Skapad den",
  "account.emptyCarts.title.selection": "Du har inga kundvagnar för valt år/urval",
  "account.emptyCarts.subTitle.selection": "Välj ett annat år eller urval för att se dina kundvagnar.",
  "mypage.carts.quantityText": "Visar {current} av {total} kundvagnar",
  "mypage.carts.addedToCart": "Kundvagnen uppdaterades",
  "mypage.carts.current": "Aktuell",
  "mypage.carts.create": "Skapa ny kundvagn",
  "minicart.carts.create": "Skapa ny kundvagn",
  "minicart.carts.createNewSuccess": "En ny kundvagn har skapats!",
  "mypage.carts.created_by": "Skapad av",
  "minicart.savedCart.messsage": "Kundvagn #{cartId} skapad den {date} av {name} är nu aktiv",
  "mypage.preview.addToCart": "Ladda kundvagn",
  "mypage.preview.addToCartImpersonate": "Logga in som företag och ladda kundvagn",
  "minicart.carts.delete": "Radera",
  "minicart.carts.deleteSuccessMsg": "Kundvagnen har raderats",
  "priceInfo.maxDiscountExceeded": "Maximalt {maxDiscount}% rabatt tillåten",
  "priceInfo.minPriceRequired": "Minimum {minPrice} per {unit} tillåtet",
  "productPage.pallet": "m2/pall",
  "b2bb2cSwitch.headline": "Besöker du oss som konsument eller handelskund",
  "discountBreakpoint.Accessories": "Ditt inköpspris från en full VPE ({num}+ stycken)",
  "findRetailer.near": "Visar resultat nära {city}",
  "areaConvert.packageEquals.Accessories": "1 styck = {areaPerPackage}{unitDisplay}",
  "units.package.short.Accessories": "Styck",
  "resilient.contactSalesInfo": "För mer information och prover, vänligen kontakta våra projektledare.",
  "resilient.contactSalesButton": "Kontakta våra projektledare",
  "fastorder.table.savings": "Besparingar",
  "stock.area.less2500": "{area} {unit} i lager",
  "stock.area.more5000": "5000+ {unit} i lager",
  "stock.area.more10000": "10000+ {unit} i lager",
  "stock.area.more25000": "25000+ {unit} i lager",
  "currency.symbol": "SEK",
  "checkout.invoice.accessoryDeliveryUs": "Frakt för tillbehör ingår inte i totalsumman och kommer att offereras separat via e-post.",
  "form.placeholder.state": "Stat",
  "priceInfo.discountType.fixedPerSqft": "Fast pris per kvadratfot",
  "priceInfo.fixedDiscountPerSqft": "Pris per kvadratfot",
  "checkout.checkoutType.orderProposalDescription": " ",
  "checkout.checkoutType.purchaseDescription": " ",
  "checkout.customAddressConsumerDescription": " ",
  "checkout.customAddressDescription": " ",
  "checkout.notification.numberLabel": "Aviseringsnummer",
  "checkout.notification.personLabel": "Aviseringsperson",
  "checkout.salonRadioV2": "Skicka till lager",
  "checkout.storeDescription": " ",
  "checkout.storeDescriptionFree": "Du har valt att göra alla leveransdatum gratis",
  "checkout.trackTrace.customerLabel": "Namn för Track & Trace",
  "checkout.trackTrace.emailLabel": "E-post för Track & Trace",
  "checkout.trackTrace.phoneLabel": "Telefonnummer för Track & Trace",
  "checkout.calendar.free": "Gratis",
  "checkout.calendar.outsideMod": "{price} (utanför standarddagar)",
  "checkout.outsideModFee.skipLabel": "Bryt veckoleverans utan kostnad",
  "checkout.outsideModFee.skipLabelInfo": " ",
  "checkout.deliveryExtras.headline": "Tilläggstjänster",
  "checkout.deliveryExtras.timedUnloadingName": "Tidslossning {amount} / leverans",
  "checkout.deliveryExtras.timedUnloadingInfo": "Önskad tid",
  "checkout.deliveryExtras.tailLiftName": "Trucklossning {amount} / leverans",
  "checkout.deliveryExtras.tailLiftInfo": " ",
  "checkout.ecoTax.notice": "Ett tillägg för eco-tax kommer att läggas till på din faktura. Tillägget baserat på innehållet i din varukorg är {amount}",
  "checkout.item.comment": "Radmärkning/Kommentar",
  "claims.text.claimant1": "UPPGIFTER OM DIG SOM LÄMNAR ANMÄLAN",
  "claims.text.claimant2": "Uppgifter markerade med * är obligatoriska och måste alltid anges i anmälan.",
  "claims.text.claimant3": "Observera att minst två bilder eller filmer måste bifogas, dessa laddas upp längre fram.",
  "claims.text.claimant4": "Kährs ordernummer börjar med 0010 och följs av sex siffror, eller 10 och följs av sju siffror. Fakturanummer börjar med 10 och följs av sju siffror.",
  "claims.text.installation1": "UPPGIFTER OM GOLVLÄGGNINGEN",
  "claims.text.installation2": "Uppgifter markerade med * är obligatoriska och måste alltid anges i anmälan.",
  "claims.text.consumer1": "UPPGIFTER OM KUNDEN/KONSUMENTEN",
  "claims.text.consumer2": "Uppgifter markerade med * är obligatoriska och måste alltid anges i anmälan.",
  "claims.text.defect1": "UPPGIFTER OM REKLAMERAT FEL",
  "claims.text.defect2": "Uppgifter markerade med * är obligatoriska och måste alltid anges i anmälan.",
  "claims.text.product1": "UPPGIFTER OM REKLAMERAD PRODUKT",
  "claims.text.product2": "Uppgifter markerade med * är obligatoriska och måste alltid anges i anmälan.",
  "claims.text.product3": "Observera att Kährs artikelnummer innehåller femton tecken. 2- och 3-stav kan sluta med ...KW 0.\nMellan KW och 0 anges två mellanslag eller ..KW240 utan mellanslag ex. 153N38EK09KW  0 eller 153N38EK09KW240.",
  "claims.text.product4": "Karelias artikelnr består av 13 siffror och börjar generellt med 643811....",
  "claims.yes": "Ja",
  "claims.no": "Nej",
  "fastorder.table.fixedPrice": "Fast pris",
  "fastorder.table.discountMode": "Rabattyp",
  "fastorder.table.discountModeFixed": "Fast pris",
  "fastorder.table.discountModePercentage": "Procent",
  "fastorder.discountModeSwitch.abort": "Avbryt",
  "fastorder.discountModeSwitch.confirm": "Bekräfta",
  "fastorder.discountModeSwitch.text": "Byt rabattyp",
  "checkout.selectPayer.createNew": "Fyll i namn",
  "checkout.createPayer.headline": "Välj annan person",
  "checkout.createPayer.description": "",
  "checkout.createPayer.lastName": "",
  "checkout.createPayer.save": "",
  "findRetailer.rating5.name": "",
  "findRetailer.rating5.description": "",
  "lang.selector.label.at": "Austria / EUR",
  "lang.selector.label.ch_fr": "Switzerland (FR) / CHF",
  "lang.selector.label.ch_de": "Switzerland (DE) / CHF",
  "lang.selector.label.de": "Germany / EUR",
  "lang.selector.label.dk": "Denmark / DKK",
  "lang.selector.label.en": "International (EN) / EUR",
  "lang.selector.label.fi": "Finland / EUR",
  "lang.selector.label.fr": "France / EUR",
  "lang.selector.label.it": "Italy / EUR",
  "lang.selector.label.no": "Norway / NOK",
  "lang.selector.label.se": "Sweden / SEK",
  "lang.selector.label.gb": "United Kingdom / GBP",
  "lang.selector.label.us": "United States / USD",
  "lang.selector.url.at": "https://www.kahrs.com/at/",
  "lang.selector.url.ch_fr": "https://kahrs.ch/",
  "lang.selector.url.ch_de": "https://kahrs.ch/de/",
  "lang.selector.url.de": "https://www.kahrs.com/de/",
  "lang.selector.url.dk": "https://www.kahrs.com/da-dk/",
  "lang.selector.url.en": "https://www.kahrs.com/en/",
  "lang.selector.url.fi": "https://www.kahrs.com/fi/",
  "lang.selector.url.fr": "https://www.kahrs.com/fr-fr/",
  "lang.selector.url.it": "https://www.kahrs.com/it-it/",
  "lang.selector.url.no": "https://www.kahrs.com/no/",
  "lang.selector.url.se": "https://www.kahrs.com/se/",
  "lang.selector.url.gb": "https://www.kahrs.com/uk/",
  "lang.selector.url.us": "https://www.kahrs.com/us/",
  "claims.verifyCustomer": "Fortsätt",
  "claims.customerNumberRequired": "Vänligen fyll i kundnummer",
  "claims.customerNotFound": "Kundnumret kunde inte hittas. Kontrollera numret och försök igen.",
  "claims.title": "",
  "claims.image.addImage": "Lägg till bild",
  "claims.images.title": "Uppladdning av bilder och dokument",
  "claims.images.description": "Minst två bilder eller filmer måste bifogas: närbild och översikt som visar vart i rummet skadan finns i förhållande till dörrposter, väggar och andra fasta föremål.",
  "claims.tableCol.productName": "Produktnamn",
  "checkout.delivery.customerRequisition.title": "",
  "checkout.excludeBonus.label": "Uteslut från kundbonus",
  "checkout.excludeBonus.description": "Denna beställning kommer inte att generera bonus/poäng för kunden.",
  "checkout.calendar.cancel": "Avbryt",
  "checkout.calendar.select": "Välj",
  "checkout.shippingNoticeNO": "",
  "pdp.link.alternative": "Fler alternativ",
  "header.location.enter": "Ange postnummer",
  "header.location.title": "Ange postnummer eller ort",
  "header.location.text": "Vi sparar ditt postnummer så att du ser återförsäljare nära dig på alla produktsidor.",
  "pdp.experience.headline": "Upplev golvet innan du bestämmer dig",
  "pdp.experience.sample.text": "Ett litet prov hem till dig",
  "pdp.experience.sample.format": "Litet format",
  "pdp.experience.store.title": "Se golvet i butik",
  "pdp.experience.store.text": "Se större prov i butik nära dig",
  "pdp.experience.store.format": "Större format",
  "pdp.experience.samplePanel.title": "Ett litet prov hem till dig",
  "pdp.experience.samplePanel.text": "Se färg och yta i ditt eget ljus, bredvid dina möbler och väggar.",
  "pdp.experience.samplePanel.button": "Beställ prov – {price}",
  "pdp.experience.storePanel.title": "Se golvet i större format i butik",
  "pdp.experience.storePanel.text": "Vi visar återförsäljare som har just det här golvet som utställningsprov.",
  "pdp.experience.storePanel.label": "Postnummer eller ort",
  "pdp.experience.storePanel.placeholder": "T.ex. 118 20 eller Stockholm",
  "pdp.experience.storePanel.useLocation": "Använd min position",
  "pdp.experience.storePanel.notFound": "Vi hittade ingen plats för sökningen. Prova ett annat postnummer eller en annan ort.",
  "pdp.experience.storePanel.locationError": "Vi kunde inte hämta din position.",
  "pdp.experience.storePanel.currentPosition": "Din nuvarande position",
  "pdp.experience.storePanel.showingNear": "Visar butiker nära",
  "pdp.experience.storePanel.changeAria": "Ändra postnummer eller ort ({location})",
  "pdp.experience.storePanel.tryAtHome": "Vill du hellre testa hemma?",
  "pdp.experience.storePanel.orderSampleLink": "Beställ ett litet prov – {price}",
  "pdp.experience.results.count": "{count} butiker inom {radius} km har golvet utställt",
  "pdp.experience.results.countOne": "1 butik inom {radius} km har golvet utställt",
  "pdp.experience.results.noneWithin": "Ingen butik inom {radius} km har golvet utställt. Närmaste butik som har det är:",
  "pdp.experience.results.showMore": "Visa {count} butiker till",
  "pdp.experience.results.showMoreOne": "Visa 1 butik till",
  "pdp.experience.results.fallback": "Tyvärr kunde vi inte hitta någon återförsäljare som har det här golvet som utställningsexemplar. Här kan du hitta alla återförsäljare som säljer Kährs golv.",
  "pdp.experience.results.hasDisplay": "Har golvet som utställningsprov",
  "pdp.experience.results.directions": "Vägbeskrivning & kontakt",
  "pdp.experience.results.openMaps": "Öppna vägbeskrivning i Google Maps",
  "pdp.experience.storePanel.locating": "Hämtar din position…",
  "stock.availableSoon": "Ej i lager – kommer snart",
  "request.orderProposal.declineReason": "Nekat",
  "areaConvert.disclaimerHerringboneChevron": "Kährs och installatörer rekommenderar att man räknar med 10 % extra kvadratmeter på grund av spill vid installation",
  "orders.search.ariaLabel": "Sök order",
  "orders.search.placeholder": "Sök",
  "orders.search.noResults": "Inget resultat",
  "orders.search.clear": "Rensa",
  "checkout.validation.pleaseFillRequiredFields": "Vänligen fyll i alla obligatoriska fält",
  "cision.searchLabel": "Search news",
  "cision.onlyRegulatory": "Only regulatory",
  "cision.noResults": "No results found for \"{query}\"",
  "cision.yearAll": "Year: All",
  "cision.rateLimitError": "Cision rate limit reached. Please try again shortly.",
  "cision.loadError": "Failed to load news. Please try again later.",
  "cision.backToNews": "← Back to all news",
  "cision.photo": "Photographer",
  "cision.files": "Files",
  "cision.media": "Media",
  "cision.quickFacts": "Quick facts",
  "cision.regulatory": " (Regulatory)",
  "downloadableFile.downloadAlt": "Download",
  "employeeCard.mailAlt": "Mail",
  "employeeCard.phoneAlt": "Phone",
  "cision.viewed": "{current} of {total} articles",
  "lang.selector.label.corporate-en": "English",
  "lang.selector.url.corporate-en": "https://www.kahrsgroup.com/en/",
  "lang.selector.label.corporate-se": "Svenska",
  "lang.selector.url.corporate-se": "https://www.kahrsgroup.com/sv-se/",
  "newUser.tagline": "Välkommen till B2B-portalen",
  "newUser.headline": "Bara ett steg kvar",
  "newUser.text": "För att komma igång med ditt konto så behöver du välja ett lösenord. Du får ett mail med en länk där du kan välja ett nytt lösenord",
  "wcag.skipNavigation": "Hoppa till innehåll",
  "wcag.arialabel.search": "Sök",
  "wcag.arialabel.close": "Stäng",
  "wcag.arialabel.back": "Tillbaka",
  "wcag.arialabel.showPassword": "Visa lösenord",
  "wcag.arialabel.hidePassword": "Dölj lösenord",
  "wcag.arialabel.expand": "Expandera",
  "wcag.arialabel.collapse": "Kollapsa",
  "wcag.arialabel.decrease": "Minska",
  "wcag.arialabel.increase": "Öka",
  "wcag.arialabel.previousSlide": "Föregående",
  "wcag.arialabel.nextSlide": "Nästa",
  "wcag.arialabel.goToSlide": "Gå till bild {{index}}",
  "wcag.arialabel.productImages": "Produktbilder",
  "wcag.arialabel.productThumbnails": "Miniatyrer av produktbilder",
  "wcag.arialabel.addToCart": "Lägg i varukorg",
  "wcag.arialabel.packagesFor": "Antal paket — {name}",
  "wcag.arialabel.removeFavorite": "Ta bort {name} från favoriter",
  "wcag.arialabel.removeFromCart": "Ta bort {name} från varukorg",
  "wcag.cartItems": "{count} varor i varukorg",
  "singleMarket.form.name": "Namn",
  "singleMarket.form.email": "E-post",
  "singleMarket.form.phone": "Telefon",
  "singleMarket.form.message": "Meddelande",
  "singleMarket.form.submit": "Skicka",
  "singleMarket.form.success": "Tack för ditt meddelande!",
  "marketsWidget.searchPlaceholder": "Sök din marknad",
  "marketsWidget.markets": "marknader",
  "marketsWidget.regions": "regioner",
  "marketsWidget.moreInformation": "Mer information",
  "marketsListing.all": "Alla",
  "marketsListing.markets": "marknader",
  "marketsListing.shopAtLocalSite": "Handla på lokal sida",
  "marketsListing.moreInformation": "Mer information"
}
